
// // DynamicPPTBuilder.jsx
// import React, { useState, useEffect, useMemo } from "react";
// import { useLocation } from "react-router-dom";
// import { Bar } from "react-chartjs-2";
// import { Pie } from "react-chartjs-2";
// import { Radar } from "react-chartjs-2";
// import { useParams } from "react-router-dom";
// import {
//   Chart as ChartJS,
//   ArcElement,
//   Tooltip,
//   Legend,
//   RadialLinearScale,
//   PointElement,
//   LineElement,
//   Filler
// } from "chart.js";
// import WaffleChart from "./WaffleChartDynamicPPT";
// import "./DynamicPPTBuilder.css";

// // required for pie chart
// ChartJS.register(ArcElement, Tooltip, Legend, RadialLinearScale, PointElement, LineElement, Filler);

// export default function DynamicPPTBuilder() {
//   const {surveyId} = useParams();
//   const {companyId} = useParams();

//   console.log(`surveyId is ${surveyId}`)
//   console.log(`surveyId is ${companyId}`)


  
//   // -------------------- Load Analytics --------------------
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [includeHighlights, setIncludeHighlights] = useState(false);
//   const [highlightOption, setHighlightOption] = useState(null);
//   const [questionMaster, setQuestionMaster] = useState({});
//   const [textboxSummary, setTextboxSummary] = useState([]);
//   const [selectedLevel, setSelectedLevel] = useState("All");
//   const [vsEnabled, setVsEnabled] = useState(false);
//   const [vsQuestion, setVsQuestion] = useState("");
//   const [vsLabel, setVsLabel] = useState("");
// const [showResponseDropdown, setShowResponseDropdown] = useState(false);
// const [selectedTextResponses, setSelectedTextResponses] = useState([]);
// const [textMode, setTextMode] = useState("suggestion"); // "suggestion" | "detailed"
// const [detailedItems, setDetailedItems] = useState([]);
// const [selectedDetailQuestions, setSelectedDetailQuestions] = useState([]);
// const [deptResponseSummary, setDeptResponseSummary] = useState([]);








// function buildQuestionMaster(surveyQuestions = []) {
//   const out = {};

//   surveyQuestions.forEach(q => {
//     const grp = q.group_name;

//     if (!out[grp]) {
//       out[grp] = { mcq: [], textbox: "" };
//     }

//     if (q.ans_type === "mcq") {
//       out[grp].mcq.push({
//         id: q.id,                 // ✅ IMPORTANT
//         question: q.question
//       });
//     }

//     if (q.ans_type === "dual_textbox") {
//       out[grp].textbox = q.question;
//     }
//   });

//   return out;
// }




// const levels = useMemo(() => {
//   const set = new Set();
//   (data || []).forEach(d => set.add(d.level));
//   return ["All", ...Array.from(set)];
// }, [data]);


//   useEffect(() => {
//     async function load() {
//       try {
//       //  const res = await fetch(`/response/adminanalytics/${surveyId}`);
//       const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/response/adminanalytics/${surveyId}/${companyId}`);
// const json = await res.json();
// setData(json.department_group_summary || []);
// setQuestionMaster(buildQuestionMaster(json.surveyquestion || []));
// setTextboxSummary(json.textbox_response_summary || []);
// setDeptResponseSummary(json.department_response_summary || []);


//       } catch (err) {
//         console.error("Load Error:", err);
//       }
//       setLoading(false);
//     }
//     load();
//   }, [surveyId]);



//   // -------------------- Derive Departments & Groups --------------------
//  // Departments should depend on selectedLevel
// const departments = useMemo(() => {
//   if (selectedLevel === "All") {
//     return (data || []).map(d => d.department);
//   }

//   return (data || [])
//     .filter(d => d.level === selectedLevel)
//     .map(d => d.department);
// }, [data, selectedLevel]);



// const allGroups = useMemo(() => {
//   const set = new Set();

//   (data || [])
//     .filter(d => selectedLevel === "All" || d.level === selectedLevel)
//     .forEach(d => d.groups.forEach(g => set.add(g.group)));

//   return Array.from(set);
// }, [data, selectedLevel]);



//   // -------------------- UI State --------------------
//   const [selectedDepts, setSelectedDepts] = useState([]);
//   const [selectedGroups, setSelectedGroups] = useState([]);
//   const [mode, setMode] = useState("positive");
//   // new
//   const [chartType, setChartType] = useState("bar"); // "bar" or "pie"

//   // NEW: Level selection

// const generateSlideTitle = (level, departments) => {
//   // Base prefix
//   let title = "Overview of the OCS scores";

//   // CASE 1: All levels + all departments
//   const allDeptNames = Array.from(new Set(data.map(d => d.department)));  
//   const allSelected = departments.length === allDeptNames.length;

//   if (level === "All" && allSelected) {
//     return `${title} - Overall`;
//   }

//   // CASE 2: Only one department selected
//   if (departments.length === 1) {
//     return `${title} - ${level} - ${departments[0]}`;
//   }

//   // CASE 3: 2–3 departments selected
//   if (departments.length >= 2 && departments.length <= 3) {
//     const joined = departments.join(" vs ");
//     return `${title} - ${level} - ${joined}`;
//   }

//   // CASE 4: More than 3 departments selected
//   if (departments.length > 3) {
//     return `${title} - ${level} - Custom`;
//   }

//   return title; // fallback
// };


//   // initialize defaults
// useEffect(() => {
//   if (!selectedLevel && levels.length > 0) {
//     setSelectedLevel(levels[0]); // default first level
//   }

//   if (departments.length > 0) {
//     setSelectedDepts(departments.slice(0, 2));
//   }
//   if (allGroups.length > 0) {
//     setSelectedGroups(allGroups.slice());
//   }

// }, [departments, allGroups, levels]);


//   // -------------------- Queue for PPT Slides --------------------
//   const [slideQueue, setSlideQueue] = useState([]);

//   const LABEL_ORDER = ["Strongly agree", "Agree", "Disagree", "Strongly disagree"];

// const calculatePieTotals = (dept) => {
//   let sa = 0, a = 0, d = 0, sd = 0;

//   const deptObjects = data.filter(
//     d =>
//       d.department === dept &&
//       (selectedLevel === "All" || d.level === selectedLevel)
//   );

//   selectedGroups.forEach((grp) => {
//     deptObjects.forEach(deptObj => {
//       const g = deptObj.groups.find(x => x.group === grp);
//       if (!g) return;

//       sa += g.strongly_agree || 0;
//       a  += g.agree || 0;
//       d  += g.disagree || 0;
//       sd += g.strongly_disagree || 0;
//     });
//   });

//   const total = sa + a + d + sd;
//   if (total === 0) return { sa: 0, a: 0, d: 0, sd: 0 };

//   return {
//     sa: Number(((sa / total) * 100).toFixed(1)),
//     a : Number(((a  / total) * 100).toFixed(1)),
//     d : Number(((d  / total) * 100).toFixed(1)),
//     sd: Number(((sd / total) * 100).toFixed(1)),
//   };
// };




//   const addSlideToQueue = () => {
//     if (selectedDepts.length === 0 || selectedGroups.length === 0) {
//       alert("Please select departments and groups.");
//       return;
//     }

// setSlideQueue((prev) => [
//   ...prev,
//   {
//     title: generateSlideTitle(selectedLevel, selectedDepts),
//     level: selectedLevel,
//     selectedDepts: [...selectedDepts],
//     selectedGroups: [...selectedGroups],
//     mode,
//     chartType,
//     includeHighlights,
//     highlightOption,

//     // NEW
//     vsConfig: vsEnabled ? {
//     question: vsQuestion,
//     label: vsLabel
//     } : null,
//     textResponses: selectedTextResponses,
//     textMode,
//     detailedItems,   // 👈 IMPORTANT
//     waffleMode: chartType === "waffle-total" ? "total" : "polarity",
//     departmentResponseSummary: deptResponseSummary,
//     department_group_summary: data
//   }
// ]);






//   };

//   const removeSlide = (index) => {
//     setSlideQueue((prev) => prev.filter((_, i) => i !== index));
//   };

//   // -------------------- Chart Builder --------------------
//   const palette = ["#4E79A7", "#F28E2B", "#76B7B2", "#E15759", "#59A14F", "#EDC948"];
//   const POS_COLOR = "#4E79A7";
//   const NEG_COLOR = "#E15759";

// const chartData = useMemo(() => {
//   if (!selectedGroups.length || !selectedDepts.length)
//     return { labels: [], datasets: [] };

//   const labels = selectedGroups;
//   let datasets = [];

//   // FILTER FUNCTION USED FOR ALL LEVEL AND SPECIFIC LEVEL
//   const getDeptObjects = (dept) =>
//     data.filter(
//       (d) =>
//         d.department === dept &&
//         (selectedLevel === "All" || d.level === selectedLevel)
//     );

//   if (mode === "positive" || mode === "negative") {
//     // POSITIVE OR NEGATIVE MODE
//     datasets = selectedDepts.map((dept, idx) => {
//       const deptObjects = getDeptObjects(dept);

//       const series = labels.map((grp) => {
//         let total = 0;
//         let count = 0;

//         deptObjects.forEach((obj) => {
//           const g = obj.groups.find((x) => x.group === grp);
//           if (g) {
//             total += mode === "positive" ? g.positive_percent : g.negative_percent;
//             count++;
//           }
//         });

//         return count > 0 ? total / count : 0; // average across levels
//       });

//       return { 
//         label: dept,
//         data: series,
//         backgroundColor: palette[idx % palette.length],
//       };
//     });
//   } else {
//     // BOTH MODE → POSITIVE + NEGATIVE STACKED
//     selectedDepts.forEach((dept) => {
//       const deptObjects = getDeptObjects(dept);

//       const posSeries = labels.map((grp) => {
//         let total = 0;
//         let count = 0;

//         deptObjects.forEach((obj) => {
//           const g = obj.groups.find((x) => x.group === grp);
//           if (g) {
//             total += g.positive_percent;
//             count++;
//           }
//         });

//         return count > 0 ? total / count : 0;
//       });

//       const negSeries = labels.map((grp) => {
//         let total = 0;
//         let count = 0;

//         deptObjects.forEach((obj) => {
//           const g = obj.groups.find((x) => x.group === grp);
//           if (g) {
//             total += g.negative_percent;
//             count++;
//           }
//         });

//         return count > 0 ? total / count : 0;
//       });

//       datasets.push({
//         label: `${dept} - Positive`,
//         data: posSeries,
//         backgroundColor: POS_COLOR,
//         stack: dept,
//       });
//       datasets.push({
//         label: `${dept} - Negative`,
//         data: negSeries,
//         backgroundColor: NEG_COLOR,
//         stack: dept,
//       });
//     });
//   }

//   return { labels, datasets };
// }, [selectedDepts, selectedGroups, selectedLevel, mode, data]);

// const DEPT_COLORS = [
//   "#4E79A7", // blue
//   "#F28E2B", // orange
//   "#59A14F", // green
//   "#E15759", // red
//   "#B07AA1", // purple
//   "#76B7B2"  // teal
// ];


// const radarChartData = useMemo(() => {
//   if (!selectedGroups.length || !selectedDepts.length) {
//     return { labels: [], datasets: [] };
//   }

//   const labels = selectedGroups;
//   const datasets = [];

//   selectedDepts.forEach((dept, idx) => {
//     const baseColor = DEPT_COLORS[idx % DEPT_COLORS.length];

//     const deptObjects = data.filter(
//       d =>
//         d.department === dept &&
//         (selectedLevel === "All" || d.level === selectedLevel)
//     );

//     const posValues = [];
//     const negValues = [];

//     labels.forEach(grp => {
//       let pos = 0, neg = 0, count = 0;

//       deptObjects.forEach(obj => {
//         const g = obj.groups.find(x => x.group === grp);
//         if (!g) return;

//         pos += g.positive_percent || 0;
//         neg += g.negative_percent || 0;
//         count++;
//       });

//       posValues.push(count ? pos / count : 0);
//       negValues.push(count ? neg / count : 0);
//     });

//     // POSITIVE
//     if (mode === "positive" || mode === "both") {
//       datasets.push({
//         label: `${dept} – Positive`,
//         data: posValues,
//         fill: true,
//         backgroundColor: `${baseColor}55`,
//         borderColor: baseColor,
//         pointBackgroundColor: baseColor,
//         borderWidth: 2
//       });
//     }

//     // NEGATIVE
//     if (mode === "negative" || mode === "both") {
//       datasets.push({
//         label: `${dept} – Negative`,
//         data: negValues,
//         fill: true,
//         backgroundColor: `${baseColor}22`,
//         borderColor: baseColor,
//         borderDash: [6, 4],          // 👈 KEY DIFFERENTIATOR
//         pointBackgroundColor: baseColor,
//         borderWidth: 2
//       });
//     }
//   });

//   return { labels, datasets };
// }, [selectedDepts, selectedGroups, selectedLevel, mode, data]);








// const normalizedTextboxResponses = useMemo(() => {
//   const out = [];

//   (textboxSummary || []).forEach(deptObj => {
//     const deptName = deptObj.department;

//     (deptObj.levels || []).forEach(levelObj => {
//       const levelName = levelObj.level;

//       // respect selected level
//       if (selectedLevel !== "All" && selectedLevel !== levelName) return;

//       (levelObj.groups || []).forEach(groupObj => {
//         const groupName = groupObj.group_name;

//         // respect selected group
//         if (!selectedGroups.includes(groupName)) return;

//         (groupObj.questions || []).forEach(q => {
//           let answers = [];

//           try {
//             answers = JSON.parse(q.selected_answer || "[]");
//           } catch {
//             answers = [];
//           }

//           answers.forEach(ans => {
//             if (ans && ans.trim()) {
//               out.push({
//                 department: deptName,
//                 level: levelName,
//                 group: groupName,
//                 question: q.question,
//                 response: ans.trim()
//               });
//             }
//           });
//         });
//       });
//     });
//   });

//   return out;
// }, [textboxSummary, selectedGroups, selectedLevel]);

// useEffect(() => {
//   const close = () => setShowResponseDropdown(false);
//   window.addEventListener("click", close);
//   return () => window.removeEventListener("click", close);
// }, []);

// useEffect(() => {
//   setSelectedTextResponses([]);
// }, [selectedGroups, selectedLevel]);


// const textResponsesForDropdown = useMemo(() => {
//   if (chartType !== "text") return [];
//   if (selectedGroups.length !== 1) return [];

//   return normalizedTextboxResponses;
// }, [chartType, selectedGroups, normalizedTextboxResponses]);




//   const chartOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//     scales: {
//       x: { stacked: mode === "both" },
//       y: { stacked: mode === "both", beginAtZero: true, max: 100 }
//     }
//   };

//   // -------------------- Download PPT --------------------
//   const downloadPPT = async () => {
//     if (slideQueue.length === 0) {
//       alert("No slides added. Add at least one dynamic slide.");
//       return;
//     }

//     const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/report/ppt/dynamic/${surveyId}/${companyId}`, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json"
//       },
//       body: JSON.stringify({
//         slides: slideQueue
//       })
//     });

//     const blob = await res.blob();
//     const url = URL.createObjectURL(blob);

//     const a = document.createElement("a");
//     a.href = url;
//     a.download = `Survey_Report_${surveyId}.pptx`;
//     a.click();
//     URL.revokeObjectURL(url);
//   };

//   // -------------------- UI --------------------
//   if (loading) return <div>Loading…</div>;
//   if (!departments.length) return <h3>No Data Found</h3>;

//   return (
//     // <div style={{ marginTop: 20 }}>
//     <div className="slide-queue">

//       <h2>Dynamic PPT Slide Builder</h2>

//       {/* Controls */}
//       {/* <div style={{ display: "flex", gap: 24, flexWrap: "wrap", marginTop: 10 }}> */}
// <div className="ppt-controls">

//         {/* LEVEL SELECTION */}
// {/* <div style={{ minWidth: 220 }}> */}
// <div className="control-card">

//   <h4>Level</h4>
//   {levels.map((lvl) => (
//     <label key={lvl} style={{ display: "block", marginTop: 6 }}>
//       <input
//         type="radio"
//         checked={selectedLevel === lvl}
//         onChange={() => {
//           setSelectedLevel(lvl);
//           setSelectedDepts([]);
//           setSelectedGroups([]);
//         }}
//       />
//       {" "}{lvl}
//     </label>
//   ))}
// </div>


//         {/* Departments */}
//         {/* <div style={{ minWidth: 220 }}> */}
//         <div className="control-card">

//           <h4>Departments</h4>
//           {departments.map((d) => (
//             <label key={d} style={{ display: "block", marginTop: 6 }}>
//               <input
//                 type="checkbox"
//                 checked={selectedDepts.includes(d)}
//                 onChange={() =>
//                   setSelectedDepts((s) =>
//                     s.includes(d) ? s.filter((x) => x !== d) : [...s, d]
//                   )
//                 }
//               />
//               {" "}{d}
//             </label>
//           ))}
//         </div>

//         {/* Groups */}
//         {/* <div style={{ minWidth: 220 }}> */}
//         <div className="control-card">

//           <h4>Groups</h4>
//           {allGroups.map((g) => (
//             <label key={g} style={{ display: "block", marginTop: 6 }}>
//               <input
//                 type="checkbox"
//                 checked={selectedGroups.includes(g)}
//                 onChange={() =>
//                   setSelectedGroups((s) =>
//                     s.includes(g) ? s.filter((x) => x !== g) : [...s, g]
//                   )
//                 }
//               />
//               {" "}{g}
//             </label>
//           ))}
//         </div>
//         {/* Chart Type */}
// <div style={{ minWidth: 160 }}>
//   <h4>Chart Type</h4>
//   <label style={{ display: "block" }}>
//     <input type="radio" name="chartType" checked={chartType === "bar"} onChange={() => setChartType("bar")} /> Bar
//   </label>
//   <label style={{ display: "block", marginTop: 6 }}>
//     <input type="radio" name="chartType" checked={chartType === "pie"} onChange={() => setChartType("pie")} /> Pie (one pie per department)
//   </label>
//     {selectedGroups.length === 1 && (
//     <label style={{ display: "block", marginTop: 6 }}>
//       <input
//         type="radio"
//         checked={chartType === "text"}
//         onChange={() => setChartType("text")}
//       /> Text
//     </label>
    
//   )}
//   <label style={{ display: "block", marginTop: 6 }}>
//   <input
//     type="radio"
//     name="chartType"
//     checked={chartType === "radar"}
//     onChange={() => setChartType("radar")}
//   /> Radar
// </label>
// <label>
//   <input
//     type="radio"
//     checked={chartType === "waffle"}
//     onChange={() => setChartType("waffle")}
//   />
//   Waffle
// </label>
// <label style={{ display: "block", marginTop: 6 }}>
//   <input
//     type="radio"
//     checked={chartType === "waffle-total"}
//     onChange={() => setChartType("waffle-total")}
//   />
//   Waffle – Overall Participation
// </label>

// </div>

        

//         {/* Mode */}
//         <div style={{ minWidth: 160 }}>
//           <h4>Mode</h4>
//           <label><input type="radio" checked={mode === "positive"} onChange={() => setMode("positive")} /> Positive</label>
//           <label><input type="radio" checked={mode === "negative"} onChange={() => setMode("negative")} /> Negative</label>
//           <label><input type="radio" checked={mode === "both"} onChange={() => setMode("both")} /> Both</label>
//         </div>
//       </div>

// {/* HIGHLIGHTS */}

// {chartType === "text" && selectedGroups.length === 1 && (
//   <div style={{ marginTop: 16 }}>
//     <h4>Text Slide Type</h4>

//     <label>
//       <input
//         type="radio"
//         checked={textMode === "suggestion"}
//         onChange={() => setTextMode("suggestion")}
//       />
//       {" "}Suggestion Slide
//     </label>

//     <br />

//     <label>
//       <input
//         type="radio"
//         checked={textMode === "detailed"}
//         onChange={() => setTextMode("detailed")}
//       />
//       {" "}Detailed as per question
//     </label>
//   </div>
// )}

// {chartType !== "text" && (
// <div style={{ minWidth: 240 }}>
//   <h4>Highlights</h4>

//   {/* Toggle checkbox */}
//   <label style={{ display: "block" }}>
//     <input
//       type="checkbox"
//       checked={includeHighlights}
//       onChange={() => {
//         setIncludeHighlights(!includeHighlights);
//         setHighlightOption(null);
//       }}
//       disabled={
//         // disable if more than 3 departments AND not overview
//         selectedLevel !== "All" && selectedDepts.length > 3
//       }
//     />
//     {" "}Include Highlights
//   </label>

//   {/* Display Option 1 & Option 2 only for 2–3 departments */}
//   {includeHighlights &&
//     selectedDepts.length >= 2 &&
//     selectedDepts.length <= 3 &&
//     selectedLevel !== "All" && (
//       <div style={{ marginTop: 10, paddingLeft: 10 }}>
        
//         <label style={{ display: "block" }}>
//           <input
//             type="radio"
//             name="highlightOption"
//             checked={highlightOption === "opt1"}
//             onChange={() => setHighlightOption("opt1")}
//           />
//           {" "}Option 1
//         </label>

//         <label style={{ display: "block", marginTop: 6 }}>
//           <input
//             type="radio"
//             name="highlightOption"
//             checked={highlightOption === "opt2"}
//             onChange={() => setHighlightOption("opt2")}
//           />
//           {" "}Option 2
//         </label>

//       </div>
//     )
    

//     }
//     {includeHighlights &&
//  selectedDepts.length === 2 &&
//  selectedGroups.length === 1 &&
//  chartType === "pie" && (

//   <div style={{ marginTop: 16, paddingLeft: 10 }}>
//     <h4>Question-wise Comparison</h4>

//     {/* VS Checkbox */}
//     <label>
//       <input
//         type="checkbox"
//         checked={vsEnabled}
//         onChange={() => {
//           setVsEnabled(!vsEnabled);
//           setVsQuestion("");
//           setVsLabel("");
//         }}
//       />
//       {" "}VS
//     </label>

//     {/* Question Dropdown */}
//     {vsEnabled && (
//       <>
//         <div style={{ marginTop: 10 }}>
//           <label>Question</label>
//           <select
//             value={vsQuestion}
//             onChange={(e) => setVsQuestion(e.target.value)}
//           >
//             <option value="">Select Question</option>
//             {(questionMaster[selectedGroups[0]]?.mcq || []).map((q) => (
//               <option key={q} value={q}>{q}</option>
//             ))}
//           </select>
//         </div>

//         {/* Label Dropdown */}
//         <div style={{ marginTop: 10 }}>
//           <label>Response Type</label>
//           <select
//             value={vsLabel}
//             onChange={(e) => setVsLabel(e.target.value)}
//           >
//             <option value="">Select Label</option>
//             {["Strongly agree", "Agree", "Disagree", "Strongly disagree"].map(l => (
//               <option key={l} value={l}>{l}</option>
//             ))}
//           </select>
//         </div>
//       </>
//     )}
//   </div>
// )}

// </div>)}

// {textMode === "detailed" && selectedGroups.length === 1 && (
//   <div style={{ marginTop: 16 }}>

//     <h4>Detailed Question Insights</h4>

//     {detailedItems.map((item, idx) => {
//       const questionOptions =
//         questionMaster[selectedGroups[0]]?.mcq || [];

//       return (
//         <div
//           key={idx}
//           style={{
//             border: "1px solid #ccc",
//             padding: 12,
//             borderRadius: 6,
//             marginBottom: 12
//           }}
//         >
//           {/* QUESTION DROPDOWN */}
//           <div style={{ position: "relative", marginBottom: 10 }}>
//             <div
//               onClick={() => {
//                 const updated = [...detailedItems];
//                 updated[idx].open = !updated[idx].open;
//                 setDetailedItems(updated);
//               }}
//               style={{
//                 border: "1px solid #ccc",
//                 padding: "6px 8px",
//                 borderRadius: 4,
//                 cursor: "pointer",
//                 background: "#fff"
//               }}
//             >
//               {item.questionText || "Select Question"}
//             </div>

//             {item.open && (
//               <div
//                 style={{
//                   position: "absolute",
//                   zIndex: 20,
//                   background: "#fff",
//                   border: "1px solid #ccc",
//                   width: "100%",
//                   maxHeight: 180,
//                   overflowY: "auto",
//                   marginTop: 4,
//                   borderRadius: 4
//                 }}
//               >
//                 {questionOptions.length === 0 && (
//                   <div style={{ padding: 8, color: "#888" }}>
//                     No questions available
//                   </div>
//                 )}

//                 {questionOptions.map((qObj) => (
//                   <div
//                     key={qObj.id}
//                     onClick={(e) => {
//                       e.stopPropagation();

//                       const updated = [...detailedItems];
//                       updated[idx] = {
//                         ...item,
//                         questionId: qObj.id,        // ✅ REQUIRED
//                         questionText: qObj.question,
//                         open: false
//                       };
//                       setDetailedItems(updated);
//                     }}
//                     style={{
//                       padding: "6px 8px",
//                       cursor: "pointer",
//                       background:
//                         item.questionId === qObj.id
//                           ? "#eef4ff"
//                           : "#fff"
//                     }}
//                   >
//                     {qObj.question}
//                   </div>
//                 ))}
//               </div>
//             )}
//           </div>

//           {/* LABEL DROPDOWN */}
//           <select
//             value={item.label}
//             onChange={(e) => {
//               const updated = [...detailedItems];
//               updated[idx] = {
//                 ...item,
//                 label: e.target.value
//               };
//               setDetailedItems(updated);
//             }}
//           >
//             <option value="Agree">Agree</option>
//             <option value="Strongly agree">Strongly Agree</option>
//             <option value="Disagree">Disagree</option>
//             <option value="Strongly disagree">Strongly Disagree</option>
//           </select>

//           <button
//             style={{ marginLeft: 10 }}
//             onClick={() =>
//               setDetailedItems(detailedItems.filter((_, i) => i !== idx))
//             }
//           >
//             Remove
//           </button>
//         </div>
//       );
//     })}

//     <button
//       onClick={() =>
//         setDetailedItems([
//           ...detailedItems,
//           {
//             questionId: null,      // ✅ REQUIRED
//             questionText: "",
//             label: "Disagree",
//             open: false
//           }
//         ])
//       }
//     >
//       ➕ Add Question Insight
//     </button>
//   </div>
// )}

// {chartType === "text" && selectedGroups.length === 1 && (
//   <div style={{ marginTop: 12, position: "relative", width: 360 }}>

//     <h4>Select Responses</h4>

//     {/* Dropdown Button */}
//     <div
//         onClick={(e) => {
//     e.stopPropagation();
//     setShowResponseDropdown(v => !v);
//   }}
//       style={{
//     position: "absolute",
//     top: "100%",
//     left: 0,
//     right: 0,
//     maxHeight: 260,
//     overflowY: "auto",
//     background: "#fff",
//     border: "1px solid #ccc",
//     borderRadius: 6,
//     marginTop: 4,
//     padding: 8,
//     zIndex: 1000
//   }}
//     >
//       {selectedTextResponses.length > 0
//         ? `${selectedTextResponses.length} response(s) selected`
//         : "Select responses"}
//     </div>

//     {/* Dropdown Panel */}
//     {showResponseDropdown && (
//       <div
//  style={{
//     position: "absolute",
//     top: "100%",
//     left: 0,
//     right: 0,
//     maxHeight: 240,              // 👈 SCROLL LIMIT
//     overflowY: "auto",           // 👈 ENABLE SCROLL
//     background: "#fff",
//     border: "1px solid #ccc",
//     borderRadius: 6,
//     marginTop: 4,
//     padding: 8,
//     zIndex: 1000
//   }}
//       >
//         {textResponsesForDropdown.length === 0 && (
//           <div style={{ color: "#888", fontStyle: "italic", padding: 6 }}>
//             No responses available
//           </div>
//         )}

//         {textResponsesForDropdown.map((r, idx) => {
//           const checked = selectedTextResponses.includes(r);

//           return (
//             <label
//               key={idx}
//               style={{
//                 display: "flex",
//                 alignItems: "flex-start",
//                 gap: 8,
//                 padding: "6px 4px",
//                 cursor: "pointer"
//               }}
//             >
//               <input
//   type="checkbox"
//   checked={checked}
//   onClick={(e) => e.stopPropagation()}   // 👈 CRITICAL
//   onChange={() =>
//     setSelectedTextResponses(prev =>
//       checked
//         ? prev.filter(x => x !== r)
//         : [...prev, r]
//     )
//   }
// />

//               <span style={{ fontSize: 13 }}>{r.response}</span>
//             </label>
//           );
//         })}
//       </div>
//     )}
//   </div>
// )}









//       {/* Add Slide Button */}
//       <button
//         onClick={addSlideToQueue}
//         style={{
//           marginTop: 15,
//           padding: "8px 16px",
//           background: "#0b6efd",
//           color: "white",
//           border: "none",
//           borderRadius: 6,
//           cursor: "pointer"
//         }}
//       >
//         ➕ Add This Slide to PPT Queue
//       </button>

//       {/* Slide Queue */}
//       <div style={{ marginTop: 20 }}>
//         <h3>Slides Added: {slideQueue.length}</h3>
//         {slideQueue.map((s, i) => (
//           <div
//             key={i}
//             style={{
//               padding: 10,
//               border: "1px solid #ddd",
//               borderRadius: 6,
//               marginBottom: 10
//             }}
//           >
//             <b>Slide {i + 1}:</b>  
//             <br />
//             Title: {s.title} <br />
//             Level: {s.level} <br />
//             Departments: {s.selectedDepts.join(", ")}<br />
//             Groups: {s.selectedGroups.join(", ")}<br />
//             Mode: {s.mode}<br />
//             Chart Type: {s.chartType}<br />
//             <button
//               onClick={() => removeSlide(i)}
//               style={{
//                 marginTop: 5,
//                 padding: "4px 10px",
//                 background: "red",
//                 color: "#fff",
//                 border: "none",
//                 borderRadius: 4,
//                 cursor: "pointer"
//               }}
//             >
//               Remove
//             </button>
//           </div>
//         ))}
//       </div>

// {/* Chart Preview */}
// {/* <div style={{ width: "100%", minHeight: 420, marginTop: 20 }}> */}
// <div className="preview-panel">

//   {chartType === "bar" && (
//     <div style={{ width: "100%", height: 420 }}>
//       <Bar data={chartData} options={chartOptions} />
//     </div>
//   )}

//   {chartType === "pie" && (
//     <div style={{ display: "flex", gap: 20, flexWrap: "wrap" }}>
//       {selectedDepts.map((dept) => {
//         const totals = calculatePieTotals(dept);
//         return (
//           <div key={dept} style={{ width: 300 }}>
//             <h4 style={{ textAlign: "center" }}>{dept}</h4>
//             <Pie
//   data={{
//     labels: LABEL_ORDER,
//     datasets: [
//       {
//         data: [
//           totals.sa,
//           totals.a,
//           totals.d,
//           totals.sd
//         ],
//         backgroundColor: ["#4CAF50", "#8BC34A", "#FF9800", "#F44336"]
//       }
//     ]
//   }}
//   options={{
//     plugins: {
//       legend: { position: "bottom" },
//       tooltip: {
//         callbacks: {
//           label: (ctx) => `${ctx.formattedValue}%`
//         }
//       },
//       datalabels: {
//         color: "#fff",
//         formatter: (v) => `${v}%`,
//         font: {
//           size: 14,
//           weight: "bold"
//         }
//       }
//     }
//   }}
// />

//           </div>
//         );
//       })}
//       {selectedDepts.length === 0 && <div>Select departments to preview pies</div>}
//     </div>
//   )}
//   {chartType === "radar" && (
//   <div style={{ width: "100%", height: 420 }}>
//     <Radar
//   data={radarChartData}
//   options={{
//     responsive: true,
//     scales: {
//       r: {
//         min: 0,
//         max: 100,
//         ticks: { stepSize: 20 }
//       }
//     },
//     plugins: {
//       legend: { position: "bottom" }
//     }
//   }}
// />

//   </div>
// )}
// {chartType === "waffle" && (
//   <div style={{ display: "flex", gap: 24, flexWrap: "wrap" }}>
//     {selectedDepts.map((dept, idx) => {
//       const deptObj = data.find(
//         d =>
//           d.department === dept &&
//           (selectedLevel === "All" || d.level === selectedLevel)
//       );

//       if (!deptObj) return null;

//       let pos = 0;
//       let neg = 0;
//       let count = 0;

//       deptObj.groups.forEach(g => {
//         if (!selectedGroups.includes(g.group)) return;
//         pos += g.positive_percent || 0;
//         neg += g.negative_percent || 0;
//         count++;
//       });

//       const avgPos = count ? Math.round(pos / count) : 0;
//       const avgNeg = count ? Math.round(neg / count) : 0;

//       return (
//         <WaffleChart
//           key={dept}
//           title={dept}
//           positive={avgPos}
//           negative={avgNeg}
//         />
//       );
//     })}
//   </div>
// )}

// {chartType === "waffle-total" && (
//   <div style={{ display: "flex", gap: 24, alignItems: "flex-start" }}>

//     {/* TOTAL PARTICIPATION WAFFLE */}
//     <WaffleChart
//       title="Overall Participation"
//       mode="total"
//       data={(() => {
//         // build dept → percent map
//         const total = (data || []).reduce(
//           (sum, d) => sum + (d.responses || 0),
//           0
//         );

//         return (data || []).map(d => ({
//           label: d.department,
//           value: total ? Math.round((d.responses / total) * 100) : 0
//         }));
//       })()}
//     />

//     {/* LEGEND */}
//     <div>
//       <h4 style={{ marginBottom: 8 }}>Departments</h4>
//       {(data || []).map(d => (
//         <div key={d.department} style={{ fontSize: 14, marginBottom: 4 }}>
//           ■ {d.department}
//         </div>
//       ))}
//     </div>

//   </div>
// )}


// </div>


//       {/* Download PPT */}
//       {/* <button
//         onClick={downloadPPT}
//         style={{
//           marginTop: 25,
//           padding: "10px 18px",
//           fontSize: 16,
//           background: "#941932",
//           color: "white",
//           border: "none",
//           borderRadius: 6,
//           cursor: "pointer"
//         }}
//       >
//         ⬇ Download PPT (All Slides)
//       </button> */}

//             <button
//         onClick={downloadPPT}
//        className="download-btn"
//       >
//         ⬇ Download PPT (All Slides)
//       </button>
//     </div>
//   );
// }




// // DynamicPPTBuilder.jsx
// import React, { useState, useEffect, useMemo } from "react";
// import { useLocation } from "react-router-dom";
// import { Bar, Pie, Radar } from "react-chartjs-2";
// import { useParams } from "react-router-dom";
// import {
//   Chart as ChartJS,
//   ArcElement,
//   Tooltip,
//   Legend,
//   RadialLinearScale,
//   PointElement,
//   LineElement,
//   Filler
// } from "chart.js";
// import WaffleChart from "./WaffleChartDynamicPPT";
// import "./DynamicPPTBuilder.css";

// // required for pie chart
// ChartJS.register(ArcElement, Tooltip, Legend, RadialLinearScale, PointElement, LineElement, Filler);

// export default function DynamicPPTBuilder() {
//   const { surveyId, companyId } = useParams();

//   // -------------------- Load Analytics --------------------
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [includeHighlights, setIncludeHighlights] = useState(false);
//   const [highlightOption, setHighlightOption] = useState(null);
//   const [questionMaster, setQuestionMaster] = useState({});
//   const [textboxSummary, setTextboxSummary] = useState([]);
//   const [selectedLevel, setSelectedLevel] = useState("All");
//   const [vsEnabled, setVsEnabled] = useState(false);
//   const [vsQuestion, setVsQuestion] = useState("");
//   const [vsLabel, setVsLabel] = useState("");
//   const [showResponseDropdown, setShowResponseDropdown] = useState(false);
//   const [selectedTextResponses, setSelectedTextResponses] = useState([]);
//   const [textMode, setTextMode] = useState("suggestion"); // "suggestion" | "detailed"
//   const [detailedItems, setDetailedItems] = useState([]);
//   const [deptResponseSummary, setDeptResponseSummary] = useState([]);

//   // ✅ NEW: Dynamic Color States
//   const [posColor, setPosColor] = useState("#4E79A7");
//   const [negColor, setNegColor] = useState("#E15759");
//   // Default palette for multiple departments
//   const [deptColors, setDeptColors] = useState([
//     "#4E79A7", "#F28E2B", "#59A14F", "#E15759", "#B07AA1", "#76B7B2", "#EDC948", "#FF9DA7"
//   ]);

//   function buildQuestionMaster(surveyQuestions = []) {
//     const out = {};
//     surveyQuestions.forEach(q => {
//       const grp = q.group_name;
//       if (!out[grp]) {
//         out[grp] = { mcq: [], textbox: "" };
//       }
//       if (q.ans_type === "mcq") {
//         out[grp].mcq.push({
//           id: q.id,
//           question: q.question
//         });
//       }
//       if (q.ans_type === "dual_textbox") {
//         out[grp].textbox = q.question;
//       }
//     });
//     return out;
//   }

//   const levels = useMemo(() => {
//     const set = new Set();
//     (data || []).forEach(d => set.add(d.level));
//     return ["All", ...Array.from(set)];
//   }, [data]);

//   useEffect(() => {
//     async function load() {
//       try {
//         const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/response/adminanalytics/${surveyId}/${companyId}`);
//         const json = await res.json();
//         setData(json.department_group_summary || []);
//         setQuestionMaster(buildQuestionMaster(json.surveyquestion || []));
//         setTextboxSummary(json.textbox_response_summary || []);
//         setDeptResponseSummary(json.department_response_summary || []);
//       } catch (err) {
//         console.error("Load Error:", err);
//       }
//       setLoading(false);
//     }
//     load();
//   }, [surveyId, companyId]);

//   // -------------------- Derive Departments & Groups --------------------
//   const departments = useMemo(() => {
//     if (selectedLevel === "All") {
//       return (data || []).map(d => d.department);
//     }
//     return (data || [])
//       .filter(d => d.level === selectedLevel)
//       .map(d => d.department);
//   }, [data, selectedLevel]);

//   const allGroups = useMemo(() => {
//     const set = new Set();
//     (data || [])
//       .filter(d => selectedLevel === "All" || d.level === selectedLevel)
//       .forEach(d => d.groups.forEach(g => set.add(g.group)));
//     return Array.from(set);
//   }, [data, selectedLevel]);

//   // -------------------- UI State --------------------
//   const [selectedDepts, setSelectedDepts] = useState([]);
//   const [selectedGroups, setSelectedGroups] = useState([]);
//   const [mode, setMode] = useState("positive");
//   const [chartType, setChartType] = useState("bar"); 

//   const generateSlideTitle = (level, departments) => {
//     let title = "Overview of the OCS scores";
//     const allDeptNames = Array.from(new Set(data.map(d => d.department)));  
//     const allSelected = departments.length === allDeptNames.length;

//     if (level === "All" && allSelected) return `${title} - Overall`;
//     if (departments.length === 1) return `${title} - ${level} - ${departments[0]}`;
//     if (departments.length >= 2 && departments.length <= 3) {
//       const joined = departments.join(" vs ");
//       return `${title} - ${level} - ${joined}`;
//     }
//     if (departments.length > 3) return `${title} - ${level} - Custom`;
//     return title; 
//   };

//   useEffect(() => {
//     if (!selectedLevel && levels.length > 0) setSelectedLevel(levels[0]); 
//     if (departments.length > 0) setSelectedDepts(departments.slice(0, 2));
//     if (allGroups.length > 0) setSelectedGroups(allGroups.slice());
//   }, [departments, allGroups, levels]);

//   const [slideQueue, setSlideQueue] = useState([]);
//   const LABEL_ORDER = ["Strongly agree", "Agree", "Disagree", "Strongly disagree"];

//   const calculatePieTotals = (dept) => {
//     let sa = 0, a = 0, d = 0, sd = 0;
//     const deptObjects = data.filter(
//       d => d.department === dept && (selectedLevel === "All" || d.level === selectedLevel)
//     );

//     selectedGroups.forEach((grp) => {
//       deptObjects.forEach(deptObj => {
//         const g = deptObj.groups.find(x => x.group === grp);
//         if (!g) return;
//         sa += g.strongly_agree || 0;
//         a  += g.agree || 0;
//         d  += g.disagree || 0;
//         sd += g.strongly_disagree || 0;
//       });
//     });

//     const total = sa + a + d + sd;
//     if (total === 0) return { sa: 0, a: 0, d: 0, sd: 0 };

//     return {
//       sa: Number(((sa / total) * 100).toFixed(1)),
//       a : Number(((a  / total) * 100).toFixed(1)),
//       d : Number(((d  / total) * 100).toFixed(1)),
//       sd: Number(((sd / total) * 100).toFixed(1)),
//     };
//   };

//   const addSlideToQueue = () => {
//     if (selectedDepts.length === 0 || selectedGroups.length === 0) {
//       alert("Please select departments and groups.");
//       return;
//     }

//     setSlideQueue((prev) => [
//       ...prev,
//       {
//         title: generateSlideTitle(selectedLevel, selectedDepts),
//         level: selectedLevel,
//         selectedDepts: [...selectedDepts],
//         selectedGroups: [...selectedGroups],
//         mode,
//         chartType,
//         includeHighlights,
//         highlightOption,
//         vsConfig: vsEnabled ? { question: vsQuestion, label: vsLabel } : null,
//         textResponses: selectedTextResponses,
//         textMode,
//         detailedItems,
//         waffleMode: chartType === "waffle-total" ? "total" : "polarity",
//         departmentResponseSummary: deptResponseSummary,
//         department_group_summary: data,
//         // ✅ NEW: Passing Custom Colors to Backend Payload!
//         customColors: {
//           positive: posColor,
//           negative: negColor,
//           palette: deptColors
//         }
//       }
//     ]);
//   };

//   const removeSlide = (index) => {
//     setSlideQueue((prev) => prev.filter((_, i) => i !== index));
//   };

//   function darkenColor(hex, factor = 0.75) {
//     if (!hex) return "#000";
//     const cleanHex = hex.replace("#", "");
//     if (cleanHex.length !== 6) return hex;
//     const r = Math.floor(parseInt(cleanHex.slice(0, 2), 16) * factor);
//     const g = Math.floor(parseInt(cleanHex.slice(2, 4), 16) * factor);
//     const b = Math.floor(parseInt(cleanHex.slice(4, 6), 16) * factor);
//     return `rgb(${r}, ${g}, ${b})`;
//   }

//   // -------------------- Chart Builder (Using Dynamic Colors) --------------------
//   const chartData = useMemo(() => {
//     if (!selectedGroups.length || !selectedDepts.length)
//       return { labels: [], datasets: [] };

//     const labels = selectedGroups;
//     let datasets = [];

//     const getDeptObjects = (dept) =>
//       data.filter(
//         (d) => d.department === dept && (selectedLevel === "All" || d.level === selectedLevel)
//       );

//     if (mode === "positive" || mode === "negative") {
//       datasets = selectedDepts.map((dept, idx) => {
//         const deptObjects = getDeptObjects(dept);
//         const series = labels.map((grp) => {
//           let total = 0; let count = 0;
//           deptObjects.forEach((obj) => {
//             const g = obj.groups.find((x) => x.group === grp);
//             if (g) {
//               total += mode === "positive" ? g.positive_percent : g.negative_percent;
//               count++;
//             }
//           });
//           return count > 0 ? total / count : 0; 
//         });

//         return { 
//           label: dept,
//           data: series,
//           backgroundColor: deptColors[idx % deptColors.length], // ✅ Dynamic
//         };
//       });
//     } else {
//       selectedDepts.forEach((dept, idx) => {
//         const deptObjects = getDeptObjects(dept);
//         const baseColor = deptColors[idx % deptColors.length]; // ✅ Dynamic
//         const darkNegColor = darkenColor(baseColor, 0.65);

//         const posSeries = labels.map((grp) => {
//           let total = 0, count = 0;
//           deptObjects.forEach((obj) => {
//             const g = obj.groups.find((x) => x.group === grp);
//             if (g) { total += g.positive_percent; count++; }
//           });
//           return count > 0 ? Number((total / count).toFixed(1)) : 0;
//         });

//         const negSeries = labels.map((grp) => {
//           let total = 0, count = 0;
//           deptObjects.forEach((obj) => {
//             const g = obj.groups.find((x) => x.group === grp);
//             if (g) { total += g.negative_percent; count++; }
//           });
//           return count > 0 ? Number((total / count).toFixed(1)) : 0;
//         });

//         datasets.push({
//           label: `${dept} - Positive`,
//           data: posSeries,
//           backgroundColor: posColor, // ✅ Dynamic
//           stack: dept,
//         });
//         datasets.push({
//           label: `${dept} - Negative`,
//           data: negSeries,
//           backgroundColor: negColor, // ✅ Dynamic
//           stack: dept,
//         });
//       });
//     }
//     return { labels, datasets };
//   }, [selectedDepts, selectedGroups, selectedLevel, mode, data, posColor, negColor, deptColors]);

//   const radarChartData = useMemo(() => {
//     if (!selectedGroups.length || !selectedDepts.length) {
//       return { labels: [], datasets: [] };
//     }

//     const labels = selectedGroups;
//     const datasets = [];

//     selectedDepts.forEach((dept, idx) => {
//       const baseColor = deptColors[idx % deptColors.length]; // ✅ Dynamic

//       const deptObjects = data.filter(
//         d => d.department === dept && (selectedLevel === "All" || d.level === selectedLevel)
//       );

//       const posValues = [];
//       const negValues = [];

//       labels.forEach(grp => {
//         let pos = 0, neg = 0, count = 0;
//         deptObjects.forEach(obj => {
//           const g = obj.groups.find(x => x.group === grp);
//           if (!g) return;
//           pos += g.positive_percent || 0;
//           neg += g.negative_percent || 0;
//           count++;
//         });
//         posValues.push(count ? pos / count : 0);
//         negValues.push(count ? neg / count : 0);
//       });

//       if (mode === "positive" || mode === "both") {
//         datasets.push({
//           label: `${dept} – Positive`,
//           data: posValues,
//           fill: true,
//           backgroundColor: `${baseColor}55`,
//           borderColor: baseColor,
//           pointBackgroundColor: baseColor,
//           borderWidth: 2
//         });
//       }

//       if (mode === "negative" || mode === "both") {
//         datasets.push({
//           label: `${dept} – Negative`,
//           data: negValues,
//           fill: true,
//           backgroundColor: `${baseColor}22`,
//           borderColor: baseColor,
//           borderDash: [6, 4], 
//           pointBackgroundColor: baseColor,
//           borderWidth: 2
//         });
//       }
//     });

//     return { labels, datasets };
//   }, [selectedDepts, selectedGroups, selectedLevel, mode, data, deptColors]);

//   // ... (Normalized text logic remains identical)
//   const normalizedTextboxResponses = useMemo(() => {
//     const out = [];
//     (textboxSummary || []).forEach(deptObj => {
//       const deptName = deptObj.department;
//       (deptObj.levels || []).forEach(levelObj => {
//         const levelName = levelObj.level;
//         if (selectedLevel !== "All" && selectedLevel !== levelName) return;
//         (levelObj.groups || []).forEach(groupObj => {
//           const groupName = groupObj.group_name;
//           if (!selectedGroups.includes(groupName)) return;
//           (groupObj.questions || []).forEach(q => {
//             let answers = [];
//             try { answers = JSON.parse(q.selected_answer || "[]"); } catch { answers = []; }
//             answers.forEach(ans => {
//               if (ans && ans.trim()) {
//                 out.push({ department: deptName, level: levelName, group: groupName, question: q.question, response: ans.trim() });
//               }
//             });
//           });
//         });
//       });
//     });
//     return out;
//   }, [textboxSummary, selectedGroups, selectedLevel]);

//   useEffect(() => {
//     const close = () => setShowResponseDropdown(false);
//     window.addEventListener("click", close);
//     return () => window.removeEventListener("click", close);
//   }, []);

//   useEffect(() => {
//     setSelectedTextResponses([]);
//   }, [selectedGroups, selectedLevel]);

//   const textResponsesForDropdown = useMemo(() => {
//     if (chartType !== "text") return [];
//     if (selectedGroups.length !== 1) return [];
//     return normalizedTextboxResponses;
//   }, [chartType, selectedGroups, normalizedTextboxResponses]);

//   const chartOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//     scales: {
//       x: { stacked: mode === "both" },
//       y: { stacked: mode === "both", beginAtZero: true, max: 100 }
//     }
//   };

//   // -------------------- Download PPT --------------------
//   const downloadPPT = async () => {
//     if (slideQueue.length === 0) {
//       alert("No slides added. Add at least one dynamic slide.");
//       return;
//     }

//     const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/report/ppt/dynamic/${surveyId}/${companyId}`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ slides: slideQueue })
//     });

//     const blob = await res.blob();
//     const url = URL.createObjectURL(blob);
//     const a = document.createElement("a");
//     a.href = url;
//     a.download = `Survey_Report_${surveyId}.pptx`;
//     a.click();
//     URL.revokeObjectURL(url);
//   };

//   if (loading) return <div>Loading…</div>;
//   if (!departments.length) return <h3>No Data Found</h3>;

//   return (
//     <div className="slide-queue">
//       <h2>Dynamic PPT Slide Builder</h2>

//       <div className="ppt-controls">
        
//         {/* ✅ NEW: THEME COLORS CONTROLS */}
//         <div className="control-card">
//           <h4>🎨 Theme Colors</h4>
//           <label style={{ display: "flex", alignItems: "center", gap: 10, marginTop: 10, cursor: "pointer" }}>
//             <input type="color" value={posColor} onChange={(e) => setPosColor(e.target.value)} style={{ padding: 0, border: "none", width: 30, height: 30, borderRadius: "50%", cursor: "pointer" }} />
//             <span>Positive Bar Color</span>
//           </label>
//           <label style={{ display: "flex", alignItems: "center", gap: 10, marginTop: 10, cursor: "pointer" }}>
//             <input type="color" value={negColor} onChange={(e) => setNegColor(e.target.value)} style={{ padding: 0, border: "none", width: 30, height: 30, borderRadius: "50%", cursor: "pointer" }} />
//             <span>Negative Bar Color</span>
//           </label>
//         </div>

//         <div className="control-card">
//           <h4>Level</h4>
//           {levels.map((lvl) => (
//             <label key={lvl} style={{ display: "block", marginTop: 6 }}>
//               <input type="radio" checked={selectedLevel === lvl} onChange={() => { setSelectedLevel(lvl); setSelectedDepts([]); setSelectedGroups([]); }} />
//               {" "}{lvl}
//             </label>
//           ))}
//         </div>

//         <div className="control-card">
//           <h4>Departments</h4>
//           {departments.map((d) => (
//             <label key={d} style={{ display: "block", marginTop: 6 }}>
//               <input type="checkbox" checked={selectedDepts.includes(d)} onChange={() => setSelectedDepts((s) => s.includes(d) ? s.filter((x) => x !== d) : [...s, d]) } />
//               {" "}{d}
//             </label>
//           ))}
//         </div>

//         <div className="control-card">
//           <h4>Groups</h4>
//           {allGroups.map((g) => (
//             <label key={g} style={{ display: "block", marginTop: 6 }}>
//               <input type="checkbox" checked={selectedGroups.includes(g)} onChange={() => setSelectedGroups((s) => s.includes(g) ? s.filter((x) => x !== g) : [...s, g]) } />
//               {" "}{g}
//             </label>
//           ))}
//         </div>

//         <div style={{ minWidth: 160 }}>
//           <h4>Chart Type</h4>
//           <label style={{ display: "block" }}>
//             <input type="radio" name="chartType" checked={chartType === "bar"} onChange={() => setChartType("bar")} /> Bar
//           </label>
//           <label style={{ display: "block", marginTop: 6 }}>
//             <input type="radio" name="chartType" checked={chartType === "pie"} onChange={() => setChartType("pie")} /> Pie (one pie per department)
//           </label>
//             {selectedGroups.length === 1 && (
//             <label style={{ display: "block", marginTop: 6 }}>
//               <input type="radio" checked={chartType === "text"} onChange={() => setChartType("text")} /> Text
//             </label>
//           )}
//           <label style={{ display: "block", marginTop: 6 }}>
//             <input type="radio" name="chartType" checked={chartType === "radar"} onChange={() => setChartType("radar")} /> Radar
//           </label>
//           <label>
//             <input type="radio" checked={chartType === "waffle"} onChange={() => setChartType("waffle")} /> Waffle
//           </label>
//           <label style={{ display: "block", marginTop: 6 }}>
//             <input type="radio" checked={chartType === "waffle-total"} onChange={() => setChartType("waffle-total")} /> Waffle – Overall Participation
//           </label>
//         </div>

//         <div style={{ minWidth: 160 }}>
//           <h4>Mode</h4>
//           <label><input type="radio" checked={mode === "positive"} onChange={() => setMode("positive")} /> Positive</label>
//           <label><input type="radio" checked={mode === "negative"} onChange={() => setMode("negative")} /> Negative</label>
//           <label><input type="radio" checked={mode === "both"} onChange={() => setMode("both")} /> Both</label>
//         </div>
//       </div>

//       {/* HIGHLIGHTS */}
//       {chartType === "text" && selectedGroups.length === 1 && (
//         <div style={{ marginTop: 16 }}>
//           <h4>Text Slide Type</h4>
//           <label><input type="radio" checked={textMode === "suggestion"} onChange={() => setTextMode("suggestion")} /> Suggestion Slide</label><br />
//           <label><input type="radio" checked={textMode === "detailed"} onChange={() => setTextMode("detailed")} /> Detailed as per question</label>
//         </div>
//       )}

//       {chartType !== "text" && (
//         <div style={{ minWidth: 240 }}>
//           <h4>Highlights</h4>
//           <label style={{ display: "block" }}>
//             <input type="checkbox" checked={includeHighlights} onChange={() => { setIncludeHighlights(!includeHighlights); setHighlightOption(null); }} disabled={selectedLevel !== "All" && selectedDepts.length > 3} />
//             {" "}Include Highlights
//           </label>

//           {includeHighlights && selectedDepts.length >= 2 && selectedDepts.length <= 3 && selectedLevel !== "All" && (
//             <div style={{ marginTop: 10, paddingLeft: 10 }}>
//               <label style={{ display: "block" }}>
//                 <input type="radio" name="highlightOption" checked={highlightOption === "opt1"} onChange={() => setHighlightOption("opt1")} />
//                 {" "}Option 1
//               </label>
//               <label style={{ display: "block", marginTop: 6 }}>
//                 <input type="radio" name="highlightOption" checked={highlightOption === "opt2"} onChange={() => setHighlightOption("opt2")} />
//                 {" "}Option 2
//               </label>
//             </div>
//           )}

//           {includeHighlights && selectedDepts.length === 2 && selectedGroups.length === 1 && chartType === "pie" && (
//             <div style={{ marginTop: 16, paddingLeft: 10 }}>
//               <h4>Question-wise Comparison</h4>
//               <label><input type="checkbox" checked={vsEnabled} onChange={() => { setVsEnabled(!vsEnabled); setVsQuestion(""); setVsLabel(""); }} />{" "}VS</label>

//               {vsEnabled && (
//                 <>
//                   <div style={{ marginTop: 10 }}>
//                     <label>Question</label>
//                     <select value={vsQuestion} onChange={(e) => setVsQuestion(e.target.value)}>
//                       <option value="">Select Question</option>
//                       {(questionMaster[selectedGroups[0]]?.mcq || []).map((q) => (
//                         <option key={q.id} value={q.question}>{q.question}</option> // ✅ FIXED KEY
//                       ))}
//                     </select>
//                   </div>
//                   <div style={{ marginTop: 10 }}>
//                     <label>Response Type</label>
//                     <select value={vsLabel} onChange={(e) => setVsLabel(e.target.value)}>
//                       <option value="">Select Label</option>
//                       {["Strongly agree", "Agree", "Disagree", "Strongly disagree"].map(l => (
//                         <option key={l} value={l}>{l}</option>
//                       ))}
//                     </select>
//                   </div>
//                 </>
//               )}
//             </div>
//           )}
//         </div>
//       )}

//       {/* ... (Detailed Items mapping logic remains identical to your code) ... */}
//       {textMode === "detailed" && selectedGroups.length === 1 && (
//         <div style={{ marginTop: 16 }}>
//           <h4>Detailed Question Insights</h4>
//           {detailedItems.map((item, idx) => {
//             const questionOptions = questionMaster[selectedGroups[0]]?.mcq || [];
//             return (
//               <div key={idx} style={{ border: "1px solid #ccc", padding: 12, borderRadius: 6, marginBottom: 12 }}>
//                 <div style={{ position: "relative", marginBottom: 10 }}>
//                   <div onClick={() => { const updated = [...detailedItems]; updated[idx].open = !updated[idx].open; setDetailedItems(updated); }} style={{ border: "1px solid #ccc", padding: "6px 8px", borderRadius: 4, cursor: "pointer", background: "#fff" }}>
//                     {item.questionText || "Select Question"}
//                   </div>
//                   {item.open && (
//                     <div style={{ position: "absolute", zIndex: 20, background: "#fff", border: "1px solid #ccc", width: "100%", maxHeight: 180, overflowY: "auto", marginTop: 4, borderRadius: 4 }}>
//                       {questionOptions.length === 0 && <div style={{ padding: 8, color: "#888" }}>No questions available</div>}
//                       {questionOptions.map((qObj) => (
//                         <div key={qObj.id} onClick={(e) => { e.stopPropagation(); const updated = [...detailedItems]; updated[idx] = { ...item, questionId: qObj.id, questionText: qObj.question, open: false }; setDetailedItems(updated); }} style={{ padding: "6px 8px", cursor: "pointer", background: item.questionId === qObj.id ? "#eef4ff" : "#fff" }}>
//                           {qObj.question}
//                         </div>
//                       ))}
//                     </div>
//                   )}
//                 </div>
//                 <select value={item.label} onChange={(e) => { const updated = [...detailedItems]; updated[idx] = { ...item, label: e.target.value }; setDetailedItems(updated); }}>
//                   <option value="Agree">Agree</option>
//                   <option value="Strongly agree">Strongly Agree</option>
//                   <option value="Disagree">Disagree</option>
//                   <option value="Strongly disagree">Strongly Disagree</option>
//                 </select>
//                 <button style={{ marginLeft: 10 }} onClick={() => setDetailedItems(detailedItems.filter((_, i) => i !== idx))}>Remove</button>
//               </div>
//             );
//           })}
//           <button onClick={() => setDetailedItems([...detailedItems, { questionId: null, questionText: "", label: "Disagree", open: false }])}>
//             ➕ Add Question Insight
//           </button>
//         </div>
//       )}

//       <button onClick={addSlideToQueue} style={{ marginTop: 15, padding: "8px 16px", background: "#0b6efd", color: "white", border: "none", borderRadius: 6, cursor: "pointer" }}>
//         ➕ Add This Slide to PPT Queue
//       </button>

//       <div style={{ marginTop: 20 }}>
//         <h3>Slides Added: {slideQueue.length}</h3>
//         {slideQueue.map((s, i) => (
//           <div key={i} style={{ padding: 10, border: "1px solid #ddd", borderRadius: 6, marginBottom: 10 }}>
//             <b>Slide {i + 1}:</b> <br />
//             Title: {s.title} <br />
//             Mode: {s.mode} | Chart Type: {s.chartType}<br />
//             Colors Included: Yes 🎨<br/>
//             <button onClick={() => removeSlide(i)} style={{ marginTop: 5, padding: "4px 10px", background: "red", color: "#fff", border: "none", borderRadius: 4, cursor: "pointer" }}>
//               Remove
//             </button>
//           </div>
//         ))}
//       </div>

//       <div className="preview-panel">
//         {chartType === "bar" && (
//           <div style={{ width: "100%", height: 420 }}>
//             <Bar data={chartData} options={chartOptions} />
//           </div>
//         )}

//         {chartType === "pie" && (
//           <div style={{ display: "flex", gap: 20, flexWrap: "wrap" }}>
//             {selectedDepts.map((dept) => {
//               const totals = calculatePieTotals(dept);
//               return (
//                 <div key={dept} style={{ width: 300 }}>
//                   <h4 style={{ textAlign: "center" }}>{dept}</h4>
//                   <Pie data={{ labels: LABEL_ORDER, datasets: [{ data: [totals.sa, totals.a, totals.d, totals.sd], backgroundColor: ["#4CAF50", "#8BC34A", "#FF9800", "#F44336"] }] }} options={{ plugins: { legend: { position: "bottom" }, datalabels: { color: "#fff", formatter: (v) => `${v}%`, font: { size: 14, weight: "bold" } } } }} />
//                 </div>
//               );
//             })}
//           </div>
//         )}

//         {chartType === "radar" && (
//           <div style={{ width: "100%", height: 420 }}>
//             <Radar data={radarChartData} options={{ responsive: true, scales: { r: { min: 0, max: 100, ticks: { stepSize: 20 } } }, plugins: { legend: { position: "bottom" } } }} />
//           </div>
//         )}
//       </div>

//       <button onClick={downloadPPT} className="download-btn">
//         ⬇ Download PPT (All Slides)
//       </button>
//     </div>
//   );
// }


// // DynamicPPTBuilder.jsx
// import React, { useState, useEffect, useMemo } from "react";
// import { useLocation } from "react-router-dom";
// import { Bar, Pie, Radar } from "react-chartjs-2";
// import { useParams } from "react-router-dom";
// import {
//   Chart as ChartJS,
//   ArcElement,
//   Tooltip,
//   Legend,
//   RadialLinearScale,
//   PointElement,
//   LineElement,
//   Filler
// } from "chart.js";
// import WaffleChart from "./WaffleChartDynamicPPT";
// import "./DynamicPPTBuilder.css";

// // required for pie chart
// ChartJS.register(ArcElement, Tooltip, Legend, RadialLinearScale, PointElement, LineElement, Filler);

// export default function DynamicPPTBuilder() {
//   const { surveyId, companyId } = useParams();

//   // -------------------- Load Analytics --------------------
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [includeHighlights, setIncludeHighlights] = useState(false);
//   const [highlightOption, setHighlightOption] = useState(null);
//   const [questionMaster, setQuestionMaster] = useState({});
//   const [textboxSummary, setTextboxSummary] = useState([]);
//   const [selectedLevel, setSelectedLevel] = useState("All");
//   const [vsEnabled, setVsEnabled] = useState(false);
//   const [vsQuestion, setVsQuestion] = useState("");
//   const [vsLabel, setVsLabel] = useState("");
//   const [showResponseDropdown, setShowResponseDropdown] = useState(false);
//   const [selectedTextResponses, setSelectedTextResponses] = useState([]);
//   const [textMode, setTextMode] = useState("suggestion"); // "suggestion" | "detailed"
//   const [detailedItems, setDetailedItems] = useState([]);
//   const [deptResponseSummary, setDeptResponseSummary] = useState([]);

//   // ✅ NEW: Dynamic Color States for Departments
//   const [posColor, setPosColor] = useState("#4E79A7");
//   const [negColor, setNegColor] = useState("#E15759");
//   const [deptColorMap, setDeptColorMap] = useState({}); // Stores chosen colors for specific departments
  
//   const DEFAULT_DEPT_COLORS = [
//     "#4E79A7", "#F28E2B", "#59A14F", "#E15759", "#B07AA1", "#76B7B2", "#EDC948", "#FF9DA7"
//   ];

//   // Helper to safely get a department's color (user chosen or fallback to default)
//   const getDeptColor = (dept, idx) => {
//     return deptColorMap[dept] || DEFAULT_DEPT_COLORS[idx % DEFAULT_DEPT_COLORS.length];
//   };

//   function buildQuestionMaster(surveyQuestions = []) {
//     const out = {};
//     surveyQuestions.forEach(q => {
//       const grp = q.group_name;
//       if (!out[grp]) {
//         out[grp] = { mcq: [], textbox: "" };
//       }
//       if (q.ans_type === "mcq") {
//         out[grp].mcq.push({ id: q.id, question: q.question });
//       }
//       if (q.ans_type === "dual_textbox") {
//         out[grp].textbox = q.question;
//       }
//     });
//     return out;
//   }

//   const levels = useMemo(() => {
//     const set = new Set();
//     (data || []).forEach(d => set.add(d.level));
//     return ["All", ...Array.from(set)];
//   }, [data]);

//   useEffect(() => {
//     async function load() {
//       try {
//         const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/response/adminanalytics/${surveyId}/${companyId}`);
//         const json = await res.json();
//         setData(json.department_group_summary || []);
//         setQuestionMaster(buildQuestionMaster(json.surveyquestion || []));
//         setTextboxSummary(json.textbox_response_summary || []);
//         setDeptResponseSummary(json.department_response_summary || []);
//       } catch (err) {
//         console.error("Load Error:", err);
//       }
//       setLoading(false);
//     }
//     load();
//   }, [surveyId, companyId]);

//   // -------------------- Derive Departments & Groups --------------------
//   const departments = useMemo(() => {
//     if (selectedLevel === "All") {
//       return (data || []).map(d => d.department);
//     }
//     return (data || []).filter(d => d.level === selectedLevel).map(d => d.department);
//   }, [data, selectedLevel]);

//   const allGroups = useMemo(() => {
//     const set = new Set();
//     (data || [])
//       .filter(d => selectedLevel === "All" || d.level === selectedLevel)
//       .forEach(d => d.groups.forEach(g => set.add(g.group)));
//     return Array.from(set);
//   }, [data, selectedLevel]);

//   // -------------------- UI State --------------------
//   const [selectedDepts, setSelectedDepts] = useState([]);
//   const [selectedGroups, setSelectedGroups] = useState([]);
//   const [mode, setMode] = useState("positive");
//   const [chartType, setChartType] = useState("bar"); 

//   const generateSlideTitle = (level, departments) => {
//     let title = "Overview of the OCS scores";
//     const allDeptNames = Array.from(new Set(data.map(d => d.department)));  
//     const allSelected = departments.length === allDeptNames.length;

//     if (level === "All" && allSelected) return `${title} - Overall`;
//     if (departments.length === 1) return `${title} - ${level} - ${departments[0]}`;
//     if (departments.length >= 2 && departments.length <= 3) {
//       const joined = departments.join(" vs ");
//       return `${title} - ${level} - ${joined}`;
//     }
//     if (departments.length > 3) return `${title} - ${level} - Custom`;
//     return title; 
//   };

//   useEffect(() => {
//     if (!selectedLevel && levels.length > 0) setSelectedLevel(levels[0]); 
//     if (departments.length > 0) setSelectedDepts(departments.slice(0, 2));
//     if (allGroups.length > 0) setSelectedGroups(allGroups.slice());
//   }, [departments, allGroups, levels]);

//   const [slideQueue, setSlideQueue] = useState([]);
//   const LABEL_ORDER = ["Strongly agree", "Agree", "Disagree", "Strongly disagree"];

//   const calculatePieTotals = (dept) => {
//     let sa = 0, a = 0, d = 0, sd = 0;
//     const deptObjects = data.filter(
//       d => d.department === dept && (selectedLevel === "All" || d.level === selectedLevel)
//     );

//     selectedGroups.forEach((grp) => {
//       deptObjects.forEach(deptObj => {
//         const g = deptObj.groups.find(x => x.group === grp);
//         if (!g) return;
//         sa += g.strongly_agree || 0;
//         a  += g.agree || 0;
//         d  += g.disagree || 0;
//         sd += g.strongly_disagree || 0;
//       });
//     });

//     const total = sa + a + d + sd;
//     if (total === 0) return { sa: 0, a: 0, d: 0, sd: 0 };

//     return {
//       sa: Number(((sa / total) * 100).toFixed(1)),
//       a : Number(((a  / total) * 100).toFixed(1)),
//       d : Number(((d  / total) * 100).toFixed(1)),
//       sd: Number(((sd / total) * 100).toFixed(1)),
//     };
//   };

//   const addSlideToQueue = () => {
//     if (selectedDepts.length === 0 || selectedGroups.length === 0) {
//       alert("Please select departments and groups.");
//       return;
//     }

//     setSlideQueue((prev) => [
//       ...prev,
//       {
//         title: generateSlideTitle(selectedLevel, selectedDepts),
//         level: selectedLevel,
//         selectedDepts: [...selectedDepts],
//         selectedGroups: [...selectedGroups],
//         mode,
//         chartType,
//         includeHighlights,
//         highlightOption,
//         vsConfig: vsEnabled ? { question: vsQuestion, label: vsLabel } : null,
//         textResponses: selectedTextResponses,
//         textMode,
//         detailedItems,
//         waffleMode: chartType === "waffle-total" ? "total" : "polarity",
//         departmentResponseSummary: deptResponseSummary,
//         department_group_summary: data,
//         // ✅ MAP SPECIFIC COLORS FOR THE SELECTED DEPARTMENTS
//         customColors: {
//           positive: posColor,
//           negative: negColor,
//           palette: selectedDepts.map((dept, idx) => getDeptColor(dept, idx))
//         }
//       }
//     ]);
//   };

//   const removeSlide = (index) => {
//     setSlideQueue((prev) => prev.filter((_, i) => i !== index));
//   };

//   function darkenColor(hex, factor = 0.75) {
//     if (!hex) return "#000";
//     const cleanHex = hex.replace("#", "");
//     if (cleanHex.length !== 6) return hex;
//     const r = Math.floor(parseInt(cleanHex.slice(0, 2), 16) * factor);
//     const g = Math.floor(parseInt(cleanHex.slice(2, 4), 16) * factor);
//     const b = Math.floor(parseInt(cleanHex.slice(4, 6), 16) * factor);
//     return `rgb(${r}, ${g}, ${b})`;
//   }

//   // -------------------- Chart Builder (Using Dynamic Colors) --------------------
//   const chartData = useMemo(() => {
//     if (!selectedGroups.length || !selectedDepts.length) return { labels: [], datasets: [] };

//     const labels = selectedGroups;
//     let datasets = [];

//     const getDeptObjects = (dept) =>
//       data.filter(
//         (d) => d.department === dept && (selectedLevel === "All" || d.level === selectedLevel)
//       );

//     if (mode === "positive" || mode === "negative") {
//       datasets = selectedDepts.map((dept, idx) => {
//         const deptObjects = getDeptObjects(dept);
//         const series = labels.map((grp) => {
//           let total = 0; let count = 0;
//           deptObjects.forEach((obj) => {
//             const g = obj.groups.find((x) => x.group === grp);
//             if (g) {
//               total += mode === "positive" ? g.positive_percent : g.negative_percent;
//               count++;
//             }
//           });
//           return count > 0 ? total / count : 0; 
//         });

//         return { 
//           label: dept,
//           data: series,
//           backgroundColor: getDeptColor(dept, idx), // ✅ Dynamic Dept Color
//         };
//       });
//     } else {
//       selectedDepts.forEach((dept, idx) => {
//         const deptObjects = getDeptObjects(dept);
        
//         const posSeries = labels.map((grp) => {
//           let total = 0, count = 0;
//           deptObjects.forEach((obj) => {
//             const g = obj.groups.find((x) => x.group === grp);
//             if (g) { total += g.positive_percent; count++; }
//           });
//           return count > 0 ? Number((total / count).toFixed(1)) : 0;
//         });

//         const negSeries = labels.map((grp) => {
//           let total = 0, count = 0;
//           deptObjects.forEach((obj) => {
//             const g = obj.groups.find((x) => x.group === grp);
//             if (g) { total += g.negative_percent; count++; }
//           });
//           return count > 0 ? Number((total / count).toFixed(1)) : 0;
//         });

//         datasets.push({
//           label: `${dept} - Positive`,
//           data: posSeries,
//           backgroundColor: posColor, // ✅ Dynamic Shared Pos Color
//           stack: dept,
//         });
//         datasets.push({
//           label: `${dept} - Negative`,
//           data: negSeries,
//           backgroundColor: negColor, // ✅ Dynamic Shared Neg Color
//           stack: dept,
//         });
//       });
//     }
//     return { labels, datasets };
//   }, [selectedDepts, selectedGroups, selectedLevel, mode, data, posColor, negColor, deptColorMap]);

//   const radarChartData = useMemo(() => {
//     if (!selectedGroups.length || !selectedDepts.length) {
//       return { labels: [], datasets: [] };
//     }

//     const labels = selectedGroups;
//     const datasets = [];

//     selectedDepts.forEach((dept, idx) => {
//       const baseColor = getDeptColor(dept, idx); // ✅ Dynamic Dept Color

//       const deptObjects = data.filter(
//         d => d.department === dept && (selectedLevel === "All" || d.level === selectedLevel)
//       );

//       const posValues = [];
//       const negValues = [];

//       labels.forEach(grp => {
//         let pos = 0, neg = 0, count = 0;
//         deptObjects.forEach(obj => {
//           const g = obj.groups.find(x => x.group === grp);
//           if (!g) return;
//           pos += g.positive_percent || 0;
//           neg += g.negative_percent || 0;
//           count++;
//         });
//         posValues.push(count ? pos / count : 0);
//         negValues.push(count ? neg / count : 0);
//       });

//       if (mode === "positive" || mode === "both") {
//         datasets.push({
//           label: `${dept} – Positive`,
//           data: posValues,
//           fill: true,
//           backgroundColor: `${baseColor}55`,
//           borderColor: baseColor,
//           pointBackgroundColor: baseColor,
//           borderWidth: 2
//         });
//       }

//       if (mode === "negative" || mode === "both") {
//         datasets.push({
//           label: `${dept} – Negative`,
//           data: negValues,
//           fill: true,
//           backgroundColor: `${baseColor}22`,
//           borderColor: baseColor,
//           borderDash: [6, 4], 
//           pointBackgroundColor: baseColor,
//           borderWidth: 2
//         });
//       }
//     });

//     return { labels, datasets };
//   }, [selectedDepts, selectedGroups, selectedLevel, mode, data, deptColorMap]);

//   // ... Normalized textbox logic remains identical
//   const normalizedTextboxResponses = useMemo(() => {
//     const out = [];
//     (textboxSummary || []).forEach(deptObj => {
//       const deptName = deptObj.department;
//       (deptObj.levels || []).forEach(levelObj => {
//         const levelName = levelObj.level;
//         if (selectedLevel !== "All" && selectedLevel !== levelName) return;
//         (levelObj.groups || []).forEach(groupObj => {
//           const groupName = groupObj.group_name;
//           if (!selectedGroups.includes(groupName)) return;
//           (groupObj.questions || []).forEach(q => {
//             let answers = [];
//             try { answers = JSON.parse(q.selected_answer || "[]"); } catch { answers = []; }
//             answers.forEach(ans => {
//               if (ans && ans.trim()) {
//                 out.push({ department: deptName, level: levelName, group: groupName, question: q.question, response: ans.trim() });
//               }
//             });
//           });
//         });
//       });
//     });
//     return out;
//   }, [textboxSummary, selectedGroups, selectedLevel]);

//   useEffect(() => {
//     const close = () => setShowResponseDropdown(false);
//     window.addEventListener("click", close);
//     return () => window.removeEventListener("click", close);
//   }, []);

//   useEffect(() => {
//     setSelectedTextResponses([]);
//   }, [selectedGroups, selectedLevel]);

//   const textResponsesForDropdown = useMemo(() => {
//     if (chartType !== "text") return [];
//     if (selectedGroups.length !== 1) return [];
//     return normalizedTextboxResponses;
//   }, [chartType, selectedGroups, normalizedTextboxResponses]);

//   const chartOptions = {
//     responsive: true,
//     maintainAspectRatio: false,
//     scales: {
//       x: { stacked: mode === "both" },
//       y: { stacked: mode === "both", beginAtZero: true, max: 100 }
//     }
//   };

//   // -------------------- Download PPT --------------------
//   const downloadPPT = async () => {
//     if (slideQueue.length === 0) {
//       alert("No slides added. Add at least one dynamic slide.");
//       return;
//     }

//     const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/report/ppt/dynamic/${surveyId}/${companyId}`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ slides: slideQueue })
//     });

//     const blob = await res.blob();
//     const url = URL.createObjectURL(blob);
//     const a = document.createElement("a");
//     a.href = url;
//     a.download = `Survey_Report_${surveyId}.pptx`;
//     a.click();
//     URL.revokeObjectURL(url);
//   };

//   if (loading) return <div>Loading…</div>;
//   if (!departments.length) return <h3>No Data Found</h3>;

//   return (
//     <div className="slide-queue">
//       <h2>Dynamic PPT Slide Builder</h2>

//       <div className="ppt-controls">
        
//         {/* ✅ NEW: SMART THEME COLORS CARD */}
//         <div className="control-card">
//           <h4>🎨 Theme Colors</h4>
          
//           {/* Show Positive/Negative pickers ONLY when stacked (Both) mode is active */}
//           {mode === "both" && chartType === "bar" && (
//             <>
//               <label style={{ display: "flex", alignItems: "center", gap: 10, marginTop: 10, cursor: "pointer" }}>
//                 <input type="color" value={posColor} onChange={(e) => setPosColor(e.target.value)} style={{ padding: 0, border: "none", width: 30, height: 30, borderRadius: "50%", cursor: "pointer" }} />
//                 <span>Positive Bar Color</span>
//               </label>
//               <label style={{ display: "flex", alignItems: "center", gap: 10, marginTop: 10, cursor: "pointer" }}>
//                 <input type="color" value={negColor} onChange={(e) => setNegColor(e.target.value)} style={{ padding: 0, border: "none", width: 30, height: 30, borderRadius: "50%", cursor: "pointer" }} />
//                 <span>Negative Bar Color</span>
//               </label>
//             </>
//           )}

//           {/* Show Individual Department pickers for Positive/Negative modes or Radar charts */}
//           {((mode !== "both" && chartType === "bar") || chartType === "radar") && selectedDepts.length > 0 && (
//             <div style={{ marginTop: 10 }}>
//               <span style={{ fontSize: "13px", fontWeight: "bold", color: "#555" }}>Department Colors:</span>
//               {selectedDepts.map((dept, idx) => (
//                 <label key={dept} style={{ display: "flex", alignItems: "center", gap: 10, marginTop: 8, cursor: "pointer" }}>
//                   <input 
//                     type="color" 
//                     value={getDeptColor(dept, idx)} 
//                     onChange={(e) => setDeptColorMap({ ...deptColorMap, [dept]: e.target.value })} 
//                     style={{ padding: 0, border: "none", width: 25, height: 25, borderRadius: "50%", cursor: "pointer" }} 
//                   />
//                   <span style={{ fontSize: "14px" }}>{dept}</span>
//                 </label>
//               ))}
//             </div>
//           )}

//           {chartType === "pie" && (
//             <p style={{ fontSize: "12px", color: "#888", marginTop: 10, fontStyle: "italic" }}>Pie charts use standard SA/A/D/SD colors.</p>
//           )}
//         </div>

//         <div className="control-card">
//           <h4>Level</h4>
//           {levels.map((lvl) => (
//             <label key={lvl} style={{ display: "block", marginTop: 6 }}>
//               <input type="radio" checked={selectedLevel === lvl} onChange={() => { setSelectedLevel(lvl); setSelectedDepts([]); setSelectedGroups([]); }} />
//               {" "}{lvl}
//             </label>
//           ))}
//         </div>

//         <div className="control-card">
//           <h4>Departments</h4>
//           {departments.map((d) => (
//             <label key={d} style={{ display: "block", marginTop: 6 }}>
//               <input type="checkbox" checked={selectedDepts.includes(d)} onChange={() => setSelectedDepts((s) => s.includes(d) ? s.filter((x) => x !== d) : [...s, d]) } />
//               {" "}{d}
//             </label>
//           ))}
//         </div>

//         <div className="control-card">
//           <h4>Groups</h4>
//           {allGroups.map((g) => (
//             <label key={g} style={{ display: "block", marginTop: 6 }}>
//               <input type="checkbox" checked={selectedGroups.includes(g)} onChange={() => setSelectedGroups((s) => s.includes(g) ? s.filter((x) => x !== g) : [...s, g]) } />
//               {" "}{g}
//             </label>
//           ))}
//         </div>

//         <div style={{ minWidth: 160 }}>
//           <h4>Chart Type</h4>
//           <label style={{ display: "block" }}>
//             <input type="radio" name="chartType" checked={chartType === "bar"} onChange={() => setChartType("bar")} /> Bar
//           </label>
//           <label style={{ display: "block", marginTop: 6 }}>
//             <input type="radio" name="chartType" checked={chartType === "pie"} onChange={() => setChartType("pie")} /> Pie (one pie per department)
//           </label>
//             {selectedGroups.length === 1 && (
//             <label style={{ display: "block", marginTop: 6 }}>
//               <input type="radio" checked={chartType === "text"} onChange={() => setChartType("text")} /> Text
//             </label>
//           )}
//           <label style={{ display: "block", marginTop: 6 }}>
//             <input type="radio" name="chartType" checked={chartType === "radar"} onChange={() => setChartType("radar")} /> Radar
//           </label>
//           <label>
//             <input type="radio" checked={chartType === "waffle"} onChange={() => setChartType("waffle")} /> Waffle
//           </label>
//           <label style={{ display: "block", marginTop: 6 }}>
//             <input type="radio" checked={chartType === "waffle-total"} onChange={() => setChartType("waffle-total")} /> Waffle – Overall Participation
//           </label>
//         </div>

//         <div style={{ minWidth: 160 }}>
//           <h4>Mode</h4>
//           <label><input type="radio" checked={mode === "positive"} onChange={() => setMode("positive")} /> Positive</label>
//           <label><input type="radio" checked={mode === "negative"} onChange={() => setMode("negative")} /> Negative</label>
//           <label><input type="radio" checked={mode === "both"} onChange={() => setMode("both")} /> Both</label>
//         </div>
//       </div>

//       {/* HIGHLIGHTS */}
//       {chartType === "text" && selectedGroups.length === 1 && (
//         <div style={{ marginTop: 16 }}>
//           <h4>Text Slide Type</h4>
//           <label><input type="radio" checked={textMode === "suggestion"} onChange={() => setTextMode("suggestion")} /> Suggestion Slide</label><br />
//           <label><input type="radio" checked={textMode === "detailed"} onChange={() => setTextMode("detailed")} /> Detailed as per question</label>
//         </div>
//       )}

//       {chartType !== "text" && (
//         <div style={{ minWidth: 240 }}>
//           <h4>Highlights</h4>
//           <label style={{ display: "block" }}>
//             <input type="checkbox" checked={includeHighlights} onChange={() => { setIncludeHighlights(!includeHighlights); setHighlightOption(null); }} disabled={selectedLevel !== "All" && selectedDepts.length > 3} />
//             {" "}Include Highlights
//           </label>

//           {includeHighlights && selectedDepts.length >= 2 && selectedDepts.length <= 3 && selectedLevel !== "All" && (
//             <div style={{ marginTop: 10, paddingLeft: 10 }}>
//               <label style={{ display: "block" }}>
//                 <input type="radio" name="highlightOption" checked={highlightOption === "opt1"} onChange={() => setHighlightOption("opt1")} />
//                 {" "}Option 1
//               </label>
//               <label style={{ display: "block", marginTop: 6 }}>
//                 <input type="radio" name="highlightOption" checked={highlightOption === "opt2"} onChange={() => setHighlightOption("opt2")} />
//                 {" "}Option 2
//               </label>
//             </div>
//           )}

//           {includeHighlights && selectedDepts.length === 2 && selectedGroups.length === 1 && chartType === "pie" && (
//             <div style={{ marginTop: 16, paddingLeft: 10 }}>
//               <h4>Question-wise Comparison</h4>
//               <label><input type="checkbox" checked={vsEnabled} onChange={() => { setVsEnabled(!vsEnabled); setVsQuestion(""); setVsLabel(""); }} />{" "}VS</label>

//               {vsEnabled && (
//                 <>
//                   <div style={{ marginTop: 10 }}>
//                     <label>Question</label>
//                     <select value={vsQuestion} onChange={(e) => setVsQuestion(e.target.value)}>
//                       <option value="">Select Question</option>
//                       {(questionMaster[selectedGroups[0]]?.mcq || []).map((q) => (
//                         <option key={q.id} value={q.question}>{q.question}</option>
//                       ))}
//                     </select>
//                   </div>
//                   <div style={{ marginTop: 10 }}>
//                     <label>Response Type</label>
//                     <select value={vsLabel} onChange={(e) => setVsLabel(e.target.value)}>
//                       <option value="">Select Label</option>
//                       {["Strongly agree", "Agree", "Disagree", "Strongly disagree"].map(l => (
//                         <option key={l} value={l}>{l}</option>
//                       ))}
//                     </select>
//                   </div>
//                 </>
//               )}
//             </div>
//           )}
//         </div>
//       )}

//       {textMode === "detailed" && selectedGroups.length === 1 && (
//         <div style={{ marginTop: 16 }}>
//           <h4>Detailed Question Insights</h4>
//           {detailedItems.map((item, idx) => {
//             const questionOptions = questionMaster[selectedGroups[0]]?.mcq || [];
//             return (
//               <div key={idx} style={{ border: "1px solid #ccc", padding: 12, borderRadius: 6, marginBottom: 12 }}>
//                 <div style={{ position: "relative", marginBottom: 10 }}>
//                   <div onClick={() => { const updated = [...detailedItems]; updated[idx].open = !updated[idx].open; setDetailedItems(updated); }} style={{ border: "1px solid #ccc", padding: "6px 8px", borderRadius: 4, cursor: "pointer", background: "#fff" }}>
//                     {item.questionText || "Select Question"}
//                   </div>
//                   {item.open && (
//                     <div style={{ position: "absolute", zIndex: 20, background: "#fff", border: "1px solid #ccc", width: "100%", maxHeight: 180, overflowY: "auto", marginTop: 4, borderRadius: 4 }}>
//                       {questionOptions.length === 0 && <div style={{ padding: 8, color: "#888" }}>No questions available</div>}
//                       {questionOptions.map((qObj) => (
//                         <div key={qObj.id} onClick={(e) => { e.stopPropagation(); const updated = [...detailedItems]; updated[idx] = { ...item, questionId: qObj.id, questionText: qObj.question, open: false }; setDetailedItems(updated); }} style={{ padding: "6px 8px", cursor: "pointer", background: item.questionId === qObj.id ? "#eef4ff" : "#fff" }}>
//                           {qObj.question}
//                         </div>
//                       ))}
//                     </div>
//                   )}
//                 </div>
//                 <select value={item.label} onChange={(e) => { const updated = [...detailedItems]; updated[idx] = { ...item, label: e.target.value }; setDetailedItems(updated); }}>
//                   <option value="Agree">Agree</option>
//                   <option value="Strongly agree">Strongly Agree</option>
//                   <option value="Disagree">Disagree</option>
//                   <option value="Strongly disagree">Strongly Disagree</option>
//                 </select>
//                 <button style={{ marginLeft: 10 }} onClick={() => setDetailedItems(detailedItems.filter((_, i) => i !== idx))}>Remove</button>
//               </div>
//             );
//           })}
//           <button onClick={() => setDetailedItems([...detailedItems, { questionId: null, questionText: "", label: "Disagree", open: false }])}>
//             ➕ Add Question Insight
//           </button>
//         </div>
//       )}

//       {chartType === "text" && selectedGroups.length === 1 && (
//         <div style={{ marginTop: 12, position: "relative", width: 360 }}>
//           <h4>Select Responses</h4>
//           <div onClick={(e) => { e.stopPropagation(); setShowResponseDropdown(v => !v); }} style={{ position: "absolute", top: "100%", left: 0, right: 0, maxHeight: 260, overflowY: "auto", background: "#fff", border: "1px solid #ccc", borderRadius: 6, marginTop: 4, padding: 8, zIndex: 1000 }}>
//             {selectedTextResponses.length > 0 ? `${selectedTextResponses.length} response(s) selected` : "Select responses"}
//           </div>
//           {showResponseDropdown && (
//             <div style={{ position: "absolute", top: "100%", left: 0, right: 0, maxHeight: 240, overflowY: "auto", background: "#fff", border: "1px solid #ccc", borderRadius: 6, marginTop: 4, padding: 8, zIndex: 1000 }}>
//               {textResponsesForDropdown.length === 0 && <div style={{ color: "#888", fontStyle: "italic", padding: 6 }}>No responses available</div>}
//               {textResponsesForDropdown.map((r, idx) => {
//                 const checked = selectedTextResponses.includes(r);
//                 return (
//                   <label key={idx} style={{ display: "flex", alignItems: "flex-start", gap: 8, padding: "6px 4px", cursor: "pointer" }}>
//                     <input type="checkbox" checked={checked} onClick={(e) => e.stopPropagation()} onChange={() => setSelectedTextResponses(prev => checked ? prev.filter(x => x !== r) : [...prev, r]) } />
//                     <span style={{ fontSize: 13 }}>{r.response}</span>
//                   </label>
//                 );
//               })}
//             </div>
//           )}
//         </div>
//       )}

//       <button onClick={addSlideToQueue} style={{ marginTop: 15, padding: "8px 16px", background: "#0b6efd", color: "white", border: "none", borderRadius: 6, cursor: "pointer" }}>
//         ➕ Add This Slide to PPT Queue
//       </button>

//       <div style={{ marginTop: 20 }}>
//         <h3>Slides Added: {slideQueue.length}</h3>
//         {slideQueue.map((s, i) => (
//           <div key={i} style={{ padding: 10, border: "1px solid #ddd", borderRadius: 6, marginBottom: 10 }}>
//             <b>Slide {i + 1}:</b> <br />
//             Title: {s.title} <br />
//             Level: {s.level} <br />
//             Departments: {s.selectedDepts.join(", ")}<br />
//             Groups: {s.selectedGroups.join(", ")}<br />
//             Mode: {s.mode}<br />
//             Chart Type: {s.chartType}<br />
//             <button onClick={() => removeSlide(i)} style={{ marginTop: 5, padding: "4px 10px", background: "red", color: "#fff", border: "none", borderRadius: 4, cursor: "pointer" }}>
//               Remove
//             </button>
//           </div>
//         ))}
//       </div>

//       <div className="preview-panel">
//         {chartType === "bar" && (
//           <div style={{ width: "100%", height: 420 }}>
//             <Bar data={chartData} options={chartOptions} />
//           </div>
//         )}

//         {chartType === "pie" && (
//           <div style={{ display: "flex", gap: 20, flexWrap: "wrap" }}>
//             {selectedDepts.map((dept) => {
//               const totals = calculatePieTotals(dept);
//               return (
//                 <div key={dept} style={{ width: 300 }}>
//                   <h4 style={{ textAlign: "center" }}>{dept}</h4>
//                   <Pie data={{ labels: LABEL_ORDER, datasets: [{ data: [totals.sa, totals.a, totals.d, totals.sd], backgroundColor: ["#4CAF50", "#8BC34A", "#FF9800", "#F44336"] }] }} options={{ plugins: { legend: { position: "bottom" }, datalabels: { color: "#fff", formatter: (v) => `${v}%`, font: { size: 14, weight: "bold" } } } }} />
//                 </div>
//               );
//             })}
//             {selectedDepts.length === 0 && <div>Select departments to preview pies</div>}
//           </div>
//         )}

//         {chartType === "radar" && (
//           <div style={{ width: "100%", height: 420 }}>
//             <Radar data={radarChartData} options={{ responsive: true, scales: { r: { min: 0, max: 100, ticks: { stepSize: 20 } } }, plugins: { legend: { position: "bottom" } } }} />
//           </div>
//         )}

//         {chartType === "waffle" && (
//           <div style={{ display: "flex", gap: 24, flexWrap: "wrap" }}>
//             {selectedDepts.map((dept) => {
//               const deptObj = data.find(d => d.department === dept && (selectedLevel === "All" || d.level === selectedLevel));
//               if (!deptObj) return null;
//               let pos = 0, neg = 0, count = 0;
//               deptObj.groups.forEach(g => {
//                 if (!selectedGroups.includes(g.group)) return;
//                 pos += g.positive_percent || 0; neg += g.negative_percent || 0; count++;
//               });
//               return <WaffleChart key={dept} title={dept} positive={count ? Math.round(pos / count) : 0} negative={count ? Math.round(neg / count) : 0} />;
//             })}
//           </div>
//         )}

//         {chartType === "waffle-total" && (
//           <div style={{ display: "flex", gap: 24, alignItems: "flex-start" }}>
//             <WaffleChart title="Overall Participation" mode="total" data={(() => {
//                 const total = (data || []).reduce((sum, d) => sum + (d.responses || 0), 0);
//                 return (data || []).map(d => ({ label: d.department, value: total ? Math.round((d.responses / total) * 100) : 0 }));
//               })()} />
//             <div>
//               <h4 style={{ marginBottom: 8 }}>Departments</h4>
//               {(data || []).map(d => <div key={d.department} style={{ fontSize: 14, marginBottom: 4 }}>■ {d.department}</div>)}
//             </div>
//           </div>
//         )}
//       </div>

//       <button onClick={downloadPPT} className="download-btn">
//         ⬇ Download PPT (All Slides)
//       </button>
//     </div>
//   );
// }


// DynamicPPTBuilder.jsx
import React, { useState, useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { Bar, Pie, Radar } from "react-chartjs-2";
import { useParams } from "react-router-dom";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler
} from "chart.js";
import WaffleChart from "./WaffleChartDynamicPPT";
import "./DynamicPPTBuilder.css";

// required for pie chart
ChartJS.register(ArcElement, Tooltip, Legend, RadialLinearScale, PointElement, LineElement, Filler);

export default function DynamicPPTBuilder() {
  const { surveyId, companyId } = useParams();

  // -------------------- Load Analytics --------------------
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [includeHighlights, setIncludeHighlights] = useState(false);
  const [highlightOption, setHighlightOption] = useState(null);
  const [questionMaster, setQuestionMaster] = useState({});
  const [textboxSummary, setTextboxSummary] = useState([]);
  const [selectedLevel, setSelectedLevel] = useState("All");
  const [vsEnabled, setVsEnabled] = useState(false);
  const [vsQuestion, setVsQuestion] = useState("");
  const [vsLabel, setVsLabel] = useState("");
  const [showResponseDropdown, setShowResponseDropdown] = useState(false);
  const [selectedTextResponses, setSelectedTextResponses] = useState([]);
  const [textMode, setTextMode] = useState("suggestion"); // "suggestion" | "detailed"
  const [detailedItems, setDetailedItems] = useState([]);
  const [deptResponseSummary, setDeptResponseSummary] = useState([]);

  // ✅ NEW: Dynamic Color States for ALL Charts
  const [posColor, setPosColor] = useState("#4E79A7");
  const [negColor, setNegColor] = useState("#E15759");
  const [neutralColor, setNeutralColor] = useState("#E0E0E0"); // For Waffle
  
  const [pieColors, setPieColors] = useState({
    sa: "#4CAF50",
    a: "#8BC34A",
    d: "#FF9800",
    sd: "#F44336"
  });

  const [deptColorMap, setDeptColorMap] = useState({}); 
  const DEFAULT_DEPT_COLORS = [
    "#4E79A7", "#F28E2B", "#59A14F", "#E15759", "#B07AA1", "#76B7B2", "#EDC948", "#FF9DA7"
  ];

  const getDeptColor = (dept, idx) => deptColorMap[dept] || DEFAULT_DEPT_COLORS[idx % DEFAULT_DEPT_COLORS.length];

  function buildQuestionMaster(surveyQuestions = []) {
    const out = {};
    surveyQuestions.forEach(q => {
      const grp = q.group_name;
      if (!out[grp]) {
        out[grp] = { mcq: [], textbox: "" };
      }
      if (q.ans_type === "mcq") {
        out[grp].mcq.push({ id: q.id, question: q.question });
      }
      if (q.ans_type === "dual_textbox") {
        out[grp].textbox = q.question;
      }
    });
    return out;
  }

  const levels = useMemo(() => {
    const set = new Set();
    (data || []).forEach(d => set.add(d.level));
    return ["All", ...Array.from(set)];
  }, [data]);

  useEffect(() => {
    async function load() {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/response/adminanalytics/${surveyId}/${companyId}`);
        const json = await res.json();
        setData(json.department_group_summary || []);
        setQuestionMaster(buildQuestionMaster(json.surveyquestion || []));
        setTextboxSummary(json.textbox_response_summary || []);
        setDeptResponseSummary(json.department_response_summary || []);
      } catch (err) {
        console.error("Load Error:", err);
      }
      setLoading(false);
    }
    load();
  }, [surveyId, companyId]);

  // -------------------- Derive Departments & Groups --------------------
  const departments = useMemo(() => {
    if (selectedLevel === "All") {
      return (data || []).map(d => d.department);
    }
    return (data || []).filter(d => d.level === selectedLevel).map(d => d.department);
  }, [data, selectedLevel]);

  const allGroups = useMemo(() => {
    const set = new Set();
    (data || [])
      .filter(d => selectedLevel === "All" || d.level === selectedLevel)
      .forEach(d => d.groups.forEach(g => set.add(g.group)));
    return Array.from(set);
  }, [data, selectedLevel]);

  const [selectedDepts, setSelectedDepts] = useState([]);
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [mode, setMode] = useState("positive");
  const [chartType, setChartType] = useState("bar"); 

  const generateSlideTitle = (level, departments) => {
    let title = "Overview of the OCS scores";
    const allDeptNames = Array.from(new Set(data.map(d => d.department)));  
    const allSelected = departments.length === allDeptNames.length;

    if (level === "All" && allSelected) return `${title} - Overall`;
    if (departments.length === 1) return `${title} - ${level} - ${departments[0]}`;
    if (departments.length >= 2 && departments.length <= 3) return `${title} - ${level} - ${departments.join(" vs ")}`;
    if (departments.length > 3) return `${title} - ${level} - Custom`;
    return title; 
  };

  useEffect(() => {
    if (!selectedLevel && levels.length > 0) setSelectedLevel(levels[0]); 
    if (departments.length > 0) setSelectedDepts(departments.slice(0, 2));
    if (allGroups.length > 0) setSelectedGroups(allGroups.slice());
  }, [departments, allGroups, levels]);

  const [slideQueue, setSlideQueue] = useState([]);
  const LABEL_ORDER = ["Strongly agree", "Agree", "Disagree", "Strongly disagree"];

  const calculatePieTotals = (dept) => {
    let sa = 0, a = 0, d = 0, sd = 0;
    const deptObjects = data.filter(
      d => d.department === dept && (selectedLevel === "All" || d.level === selectedLevel)
    );

    selectedGroups.forEach((grp) => {
      deptObjects.forEach(deptObj => {
        const g = deptObj.groups.find(x => x.group === grp);
        if (!g) return;
        sa += g.strongly_agree || 0;
        a  += g.agree || 0;
        d  += g.disagree || 0;
        sd += g.strongly_disagree || 0;
      });
    });

    const total = sa + a + d + sd;
    if (total === 0) return { sa: 0, a: 0, d: 0, sd: 0 };
    return {
      sa: Number(((sa / total) * 100).toFixed(1)),
      a : Number(((a  / total) * 100).toFixed(1)),
      d : Number(((d  / total) * 100).toFixed(1)),
      sd: Number(((sd / total) * 100).toFixed(1)),
    };
  };

  const addSlideToQueue = () => {
    if (selectedDepts.length === 0 || selectedGroups.length === 0) {
      alert("Please select departments and groups.");
      return;
    }

    setSlideQueue((prev) => [
      ...prev,
      {
        title: generateSlideTitle(selectedLevel, selectedDepts),
        level: selectedLevel,
        selectedDepts: [...selectedDepts],
        selectedGroups: [...selectedGroups],
        mode,
        chartType,
        includeHighlights,
        highlightOption,
        vsConfig: vsEnabled ? { question: vsQuestion, label: vsLabel } : null,
        textResponses: selectedTextResponses,
        textMode,
        detailedItems,
        waffleMode: chartType === "waffle-total" ? "total" : "polarity",
        departmentResponseSummary: deptResponseSummary,
        department_group_summary: data,
        // ✅ MAP SPECIFIC COLORS FOR ALL CHARTS TO SEND TO BACKEND
        customColors: {
          positive: posColor,
          negative: negColor,
          neutral: neutralColor,
          pie: [pieColors.sa, pieColors.a, pieColors.d, pieColors.sd],
          palette: selectedDepts.map((dept, idx) => getDeptColor(dept, idx))
        }
      }
    ]);
  };

  const removeSlide = (index) => {
    setSlideQueue((prev) => prev.filter((_, i) => i !== index));
  };

  function darkenColor(hex, factor = 0.75) {
    if (!hex) return "#000";
    const cleanHex = hex.replace("#", "");
    if (cleanHex.length !== 6) return hex;
    const r = Math.floor(parseInt(cleanHex.slice(0, 2), 16) * factor);
    const g = Math.floor(parseInt(cleanHex.slice(2, 4), 16) * factor);
    const b = Math.floor(parseInt(cleanHex.slice(4, 6), 16) * factor);
    return `rgb(${r}, ${g}, ${b})`;
  }

  // -------------------- Chart Builder (Using Dynamic Colors) --------------------
  const chartData = useMemo(() => {
    if (!selectedGroups.length || !selectedDepts.length) return { labels: [], datasets: [] };

    const labels = selectedGroups;
    let datasets = [];

    const getDeptObjects = (dept) =>
      data.filter(
        (d) => d.department === dept && (selectedLevel === "All" || d.level === selectedLevel)
      );

    if (mode === "positive" || mode === "negative") {
      datasets = selectedDepts.map((dept, idx) => {
        const deptObjects = getDeptObjects(dept);
        const series = labels.map((grp) => {
          let total = 0; let count = 0;
          deptObjects.forEach((obj) => {
            const g = obj.groups.find((x) => x.group === grp);
            if (g) {
              total += mode === "positive" ? g.positive_percent : g.negative_percent;
              count++;
            }
          });
          return count > 0 ? total / count : 0; 
        });

        return { 
          label: dept,
          data: series,
          backgroundColor: getDeptColor(dept, idx), 
        };
      });
    } else {
      selectedDepts.forEach((dept, idx) => {
        const deptObjects = getDeptObjects(dept);
        
        const posSeries = labels.map((grp) => {
          let total = 0, count = 0;
          deptObjects.forEach((obj) => {
            const g = obj.groups.find((x) => x.group === grp);
            if (g) { total += g.positive_percent; count++; }
          });
          return count > 0 ? Number((total / count).toFixed(1)) : 0;
        });

        const negSeries = labels.map((grp) => {
          let total = 0, count = 0;
          deptObjects.forEach((obj) => {
            const g = obj.groups.find((x) => x.group === grp);
            if (g) { total += g.negative_percent; count++; }
          });
          return count > 0 ? Number((total / count).toFixed(1)) : 0;
        });

        datasets.push({
          label: `${dept} - Positive`,
          data: posSeries,
          backgroundColor: posColor, 
          stack: dept,
        });
        datasets.push({
          label: `${dept} - Negative`,
          data: negSeries,
          backgroundColor: negColor, 
          stack: dept,
        });
      });
    }
    return { labels, datasets };
  }, [selectedDepts, selectedGroups, selectedLevel, mode, data, posColor, negColor, deptColorMap]);

  const radarChartData = useMemo(() => {
    if (!selectedGroups.length || !selectedDepts.length) {
      return { labels: [], datasets: [] };
    }

    const labels = selectedGroups;
    const datasets = [];

    selectedDepts.forEach((dept, idx) => {
      const baseColor = getDeptColor(dept, idx); 

      const deptObjects = data.filter(
        d => d.department === dept && (selectedLevel === "All" || d.level === selectedLevel)
      );

      const posValues = [];
      const negValues = [];

      labels.forEach(grp => {
        let pos = 0, neg = 0, count = 0;
        deptObjects.forEach(obj => {
          const g = obj.groups.find(x => x.group === grp);
          if (!g) return;
          pos += g.positive_percent || 0;
          neg += g.negative_percent || 0;
          count++;
        });
        posValues.push(count ? pos / count : 0);
        negValues.push(count ? neg / count : 0);
      });

      if (mode === "positive" || mode === "both") {
        datasets.push({
          label: `${dept} – Positive`,
          data: posValues,
          fill: true,
          backgroundColor: `${baseColor}55`,
          borderColor: baseColor,
          pointBackgroundColor: baseColor,
          borderWidth: 2
        });
      }

      if (mode === "negative" || mode === "both") {
        datasets.push({
          label: `${dept} – Negative`,
          data: negValues,
          fill: true,
          backgroundColor: `${baseColor}22`,
          borderColor: baseColor,
          borderDash: [6, 4], 
          pointBackgroundColor: baseColor,
          borderWidth: 2
        });
      }
    });

    return { labels, datasets };
  }, [selectedDepts, selectedGroups, selectedLevel, mode, data, deptColorMap]);

  const normalizedTextboxResponses = useMemo(() => {
    const out = [];
    (textboxSummary || []).forEach(deptObj => {
      const deptName = deptObj.department;
      (deptObj.levels || []).forEach(levelObj => {
        const levelName = levelObj.level;
        if (selectedLevel !== "All" && selectedLevel !== levelName) return;
        (levelObj.groups || []).forEach(groupObj => {
          const groupName = groupObj.group_name;
          if (!selectedGroups.includes(groupName)) return;
          (groupObj.questions || []).forEach(q => {
            let answers = [];
            try { answers = JSON.parse(q.selected_answer || "[]"); } catch { answers = []; }
            answers.forEach(ans => {
              if (ans && ans.trim()) {
                out.push({ department: deptName, level: levelName, group: groupName, question: q.question, response: ans.trim() });
              }
            });
          });
        });
      });
    });
    return out;
  }, [textboxSummary, selectedGroups, selectedLevel]);

  useEffect(() => {
    const close = () => setShowResponseDropdown(false);
    window.addEventListener("click", close);
    return () => window.removeEventListener("click", close);
  }, []);

  useEffect(() => {
    setSelectedTextResponses([]);
  }, [selectedGroups, selectedLevel]);

  const textResponsesForDropdown = useMemo(() => {
    if (chartType !== "text") return [];
    if (selectedGroups.length !== 1) return [];
    return normalizedTextboxResponses;
  }, [chartType, selectedGroups, normalizedTextboxResponses]);

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: { stacked: mode === "both" },
      y: { stacked: mode === "both", beginAtZero: true, max: 100 }
    }
  };

  const downloadPPT = async () => {
    if (slideQueue.length === 0) {
      alert("No slides added. Add at least one dynamic slide.");
      return;
    }

    const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/report/ppt/dynamic/${surveyId}/${companyId}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ slides: slideQueue })
    });

    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Survey_Report_${surveyId}.pptx`;
    a.click();
    URL.revokeObjectURL(url);
  };

  if (loading) return <div>Loading…</div>;
  if (!departments.length) return <h3>No Data Found</h3>;

  return (
    <div className="slide-queue">
      <h2>Dynamic PPT Slide Builder</h2>

      <div className="ppt-controls">
        
        {/* ✅ SMART THEME COLORS CARD FOR ALL CHARTS */}
        <div className="control-card">
          <h4>🎨 Theme Colors</h4>
          
          {/* BAR CHART (BOTH) OR WAFFLE (POLARITY) */}
          {((mode === "both" && chartType === "bar") || chartType === "waffle") && (
            <>
              <label style={{ display: "flex", alignItems: "center", gap: 10, marginTop: 10, cursor: "pointer" }}>
                <input type="color" value={posColor} onChange={(e) => setPosColor(e.target.value)} style={{ padding: 0, border: "none", width: 30, height: 30, borderRadius: "50%", cursor: "pointer" }} />
                <span style={{ fontSize: "14px" }}>Positive Color</span>
              </label>
              <label style={{ display: "flex", alignItems: "center", gap: 10, marginTop: 10, cursor: "pointer" }}>
                <input type="color" value={negColor} onChange={(e) => setNegColor(e.target.value)} style={{ padding: 0, border: "none", width: 30, height: 30, borderRadius: "50%", cursor: "pointer" }} />
                <span style={{ fontSize: "14px" }}>Negative Color</span>
              </label>
              {chartType === "waffle" && (
                <label style={{ display: "flex", alignItems: "center", gap: 10, marginTop: 10, cursor: "pointer" }}>
                  <input type="color" value={neutralColor} onChange={(e) => setNeutralColor(e.target.value)} style={{ padding: 0, border: "none", width: 30, height: 30, borderRadius: "50%", cursor: "pointer" }} />
                  <span style={{ fontSize: "14px" }}>Neutral Color</span>
                </label>
              )}
            </>
          )}

          {/* BAR CHART (POS/NEG), RADAR, OR TOTAL WAFFLE */}
          {(((mode !== "both" && chartType === "bar") || chartType === "radar" || chartType === "waffle-total") && selectedDepts.length > 0) && (
            <div style={{ marginTop: 10 }}>
              <span style={{ fontSize: "13px", fontWeight: "bold", color: "#555" }}>Department Colors:</span>
              {selectedDepts.map((dept, idx) => (
                <label key={dept} style={{ display: "flex", alignItems: "center", gap: 10, marginTop: 8, cursor: "pointer" }}>
                  <input type="color" value={getDeptColor(dept, idx)} onChange={(e) => setDeptColorMap({ ...deptColorMap, [dept]: e.target.value })} style={{ padding: 0, border: "none", width: 25, height: 25, borderRadius: "50%", cursor: "pointer" }} />
                  <span style={{ fontSize: "14px" }}>{dept}</span>
                </label>
              ))}
            </div>
          )}

          {/* PIE CHART SPECIFIC COLORS */}
          {chartType === "pie" && (
            <div style={{ marginTop: 10 }}>
              <span style={{ fontSize: "13px", fontWeight: "bold", color: "#555" }}>Pie Slices:</span>
              <label style={{ display: "flex", alignItems: "center", gap: 10, marginTop: 8, cursor: "pointer" }}>
                <input type="color" value={pieColors.sa} onChange={(e) => setPieColors({...pieColors, sa: e.target.value})} style={{ padding: 0, border: "none", width: 25, height: 25, borderRadius: "50%", cursor: "pointer" }} />
                <span style={{ fontSize: "14px" }}>Strongly Agree</span>
              </label>
              <label style={{ display: "flex", alignItems: "center", gap: 10, marginTop: 8, cursor: "pointer" }}>
                <input type="color" value={pieColors.a} onChange={(e) => setPieColors({...pieColors, a: e.target.value})} style={{ padding: 0, border: "none", width: 25, height: 25, borderRadius: "50%", cursor: "pointer" }} />
                <span style={{ fontSize: "14px" }}>Agree</span>
              </label>
              <label style={{ display: "flex", alignItems: "center", gap: 10, marginTop: 8, cursor: "pointer" }}>
                <input type="color" value={pieColors.d} onChange={(e) => setPieColors({...pieColors, d: e.target.value})} style={{ padding: 0, border: "none", width: 25, height: 25, borderRadius: "50%", cursor: "pointer" }} />
                <span style={{ fontSize: "14px" }}>Disagree</span>
              </label>
              <label style={{ display: "flex", alignItems: "center", gap: 10, marginTop: 8, cursor: "pointer" }}>
                <input type="color" value={pieColors.sd} onChange={(e) => setPieColors({...pieColors, sd: e.target.value})} style={{ padding: 0, border: "none", width: 25, height: 25, borderRadius: "50%", cursor: "pointer" }} />
                <span style={{ fontSize: "14px" }}>Strongly Disagree</span>
              </label>
            </div>
          )}
        </div>

        <div className="control-card">
          <h4>Level</h4>
          {levels.map((lvl) => (
            <label key={lvl} style={{ display: "block", marginTop: 6 }}>
              <input type="radio" checked={selectedLevel === lvl} onChange={() => { setSelectedLevel(lvl); setSelectedDepts([]); setSelectedGroups([]); }} />
              {" "}{lvl}
            </label>
          ))}
        </div>

        <div className="control-card">
          <h4>Departments</h4>
          {departments.map((d) => (
            <label key={d} style={{ display: "block", marginTop: 6 }}>
              <input type="checkbox" checked={selectedDepts.includes(d)} onChange={() => setSelectedDepts((s) => s.includes(d) ? s.filter((x) => x !== d) : [...s, d]) } />
              {" "}{d}
            </label>
          ))}
        </div>

        <div className="control-card">
          <h4>Groups</h4>
          {allGroups.map((g) => (
            <label key={g} style={{ display: "block", marginTop: 6 }}>
              <input type="checkbox" checked={selectedGroups.includes(g)} onChange={() => setSelectedGroups((s) => s.includes(g) ? s.filter((x) => x !== g) : [...s, g]) } />
              {" "}{g}
            </label>
          ))}
        </div>

        <div style={{ minWidth: 160 }}>
          <h4>Chart Type</h4>
          <label style={{ display: "block" }}>
            <input type="radio" name="chartType" checked={chartType === "bar"} onChange={() => setChartType("bar")} /> Bar
          </label>
          <label style={{ display: "block", marginTop: 6 }}>
            <input type="radio" name="chartType" checked={chartType === "pie"} onChange={() => setChartType("pie")} /> Pie (one pie per dept)
          </label>
            {selectedGroups.length === 1 && (
            <label style={{ display: "block", marginTop: 6 }}>
              <input type="radio" checked={chartType === "text"} onChange={() => setChartType("text")} /> Text
            </label>
          )}
          <label style={{ display: "block", marginTop: 6 }}>
            <input type="radio" name="chartType" checked={chartType === "radar"} onChange={() => setChartType("radar")} /> Radar
          </label>
          <label>
            <input type="radio" checked={chartType === "waffle"} onChange={() => setChartType("waffle")} /> Waffle
          </label>
          <label style={{ display: "block", marginTop: 6 }}>
            <input type="radio" checked={chartType === "waffle-total"} onChange={() => setChartType("waffle-total")} /> Waffle – Overall
          </label>
        </div>

        <div style={{ minWidth: 160 }}>
          <h4>Mode</h4>
          <label><input type="radio" checked={mode === "positive"} onChange={() => setMode("positive")} /> Positive</label>
          <label><input type="radio" checked={mode === "negative"} onChange={() => setMode("negative")} /> Negative</label>
          <label><input type="radio" checked={mode === "both"} onChange={() => setMode("both")} /> Both</label>
        </div>
      </div>

      {/* HIGHLIGHTS and TEXT UI logic remains exactly the same */}
      {chartType === "text" && selectedGroups.length === 1 && (
        <div style={{ marginTop: 16 }}>
          <h4>Text Slide Type</h4>
          <label><input type="radio" checked={textMode === "suggestion"} onChange={() => setTextMode("suggestion")} /> Suggestion Slide</label><br />
          <label><input type="radio" checked={textMode === "detailed"} onChange={() => setTextMode("detailed")} /> Detailed as per question</label>
        </div>
      )}

      {chartType !== "text" && (
        <div style={{ minWidth: 240 }}>
          <h4>Highlights</h4>
          <label style={{ display: "block" }}>
            <input type="checkbox" checked={includeHighlights} onChange={() => { setIncludeHighlights(!includeHighlights); setHighlightOption(null); }} disabled={selectedLevel !== "All" && selectedDepts.length > 3} />
            {" "}Include Highlights
          </label>

          {includeHighlights && selectedDepts.length >= 2 && selectedDepts.length <= 3 && selectedLevel !== "All" && (
            <div style={{ marginTop: 10, paddingLeft: 10 }}>
              <label style={{ display: "block" }}>
                <input type="radio" name="highlightOption" checked={highlightOption === "opt1"} onChange={() => setHighlightOption("opt1")} /> Option 1
              </label>
              <label style={{ display: "block", marginTop: 6 }}>
                <input type="radio" name="highlightOption" checked={highlightOption === "opt2"} onChange={() => setHighlightOption("opt2")} /> Option 2
              </label>
            </div>
          )}

          {includeHighlights && selectedDepts.length === 2 && selectedGroups.length === 1 && chartType === "pie" && (
            <div style={{ marginTop: 16, paddingLeft: 10 }}>
              <h4>Question-wise Comparison</h4>
              <label><input type="checkbox" checked={vsEnabled} onChange={() => { setVsEnabled(!vsEnabled); setVsQuestion(""); setVsLabel(""); }} /> VS</label>

              {vsEnabled && (
                <>
                  <div style={{ marginTop: 10 }}>
                    <label>Question</label>
                    <select value={vsQuestion} onChange={(e) => setVsQuestion(e.target.value)}>
                      <option value="">Select Question</option>
                      {(questionMaster[selectedGroups[0]]?.mcq || []).map((q) => (
                        <option key={q.id} value={q.question}>{q.question}</option>
                      ))}
                    </select>
                  </div>
                  <div style={{ marginTop: 10 }}>
                    <label>Response Type</label>
                    <select value={vsLabel} onChange={(e) => setVsLabel(e.target.value)}>
                      <option value="">Select Label</option>
                      {["Strongly agree", "Agree", "Disagree", "Strongly disagree"].map(l => (
                        <option key={l} value={l}>{l}</option>
                      ))}
                    </select>
                  </div>
                </>
              )}
            </div>
          )}
        </div>
      )}

      {textMode === "detailed" && selectedGroups.length === 1 && (
        <div style={{ marginTop: 16 }}>
          <h4>Detailed Question Insights</h4>
          {detailedItems.map((item, idx) => {
            const questionOptions = questionMaster[selectedGroups[0]]?.mcq || [];
            return (
              <div key={idx} style={{ border: "1px solid #ccc", padding: 12, borderRadius: 6, marginBottom: 12 }}>
                <div style={{ position: "relative", marginBottom: 10 }}>
                  <div onClick={() => { const updated = [...detailedItems]; updated[idx].open = !updated[idx].open; setDetailedItems(updated); }} style={{ border: "1px solid #ccc", padding: "6px 8px", borderRadius: 4, cursor: "pointer", background: "#fff" }}>
                    {item.questionText || "Select Question"}
                  </div>
                  {item.open && (
                    <div style={{ position: "absolute", zIndex: 20, background: "#fff", border: "1px solid #ccc", width: "100%", maxHeight: 180, overflowY: "auto", marginTop: 4, borderRadius: 4 }}>
                      {questionOptions.length === 0 && <div style={{ padding: 8, color: "#888" }}>No questions available</div>}
                      {questionOptions.map((qObj) => (
                        <div key={qObj.id} onClick={(e) => { e.stopPropagation(); const updated = [...detailedItems]; updated[idx] = { ...item, questionId: qObj.id, questionText: qObj.question, open: false }; setDetailedItems(updated); }} style={{ padding: "6px 8px", cursor: "pointer", background: item.questionId === qObj.id ? "#eef4ff" : "#fff" }}>
                          {qObj.question}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                <select value={item.label} onChange={(e) => { const updated = [...detailedItems]; updated[idx] = { ...item, label: e.target.value }; setDetailedItems(updated); }}>
                  <option value="Agree">Agree</option>
                  <option value="Strongly agree">Strongly Agree</option>
                  <option value="Disagree">Disagree</option>
                  <option value="Strongly disagree">Strongly Disagree</option>
                </select>
                <button style={{ marginLeft: 10 }} onClick={() => setDetailedItems(detailedItems.filter((_, i) => i !== idx))}>Remove</button>
              </div>
            );
          })}
          <button onClick={() => setDetailedItems([...detailedItems, { questionId: null, questionText: "", label: "Disagree", open: false }])}>
            ➕ Add Question Insight
          </button>
        </div>
      )}

      {chartType === "text" && selectedGroups.length === 1 && (
        <div style={{ marginTop: 12, position: "relative", width: 360 }}>
          <h4>Select Responses</h4>
          <div onClick={(e) => { e.stopPropagation(); setShowResponseDropdown(v => !v); }} style={{ position: "absolute", top: "100%", left: 0, right: 0, maxHeight: 260, overflowY: "auto", background: "#fff", border: "1px solid #ccc", borderRadius: 6, marginTop: 4, padding: 8, zIndex: 1000 }}>
            {selectedTextResponses.length > 0 ? `${selectedTextResponses.length} response(s) selected` : "Select responses"}
          </div>
          {showResponseDropdown && (
            <div style={{ position: "absolute", top: "100%", left: 0, right: 0, maxHeight: 240, overflowY: "auto", background: "#fff", border: "1px solid #ccc", borderRadius: 6, marginTop: 4, padding: 8, zIndex: 1000 }}>
              {textResponsesForDropdown.length === 0 && <div style={{ color: "#888", fontStyle: "italic", padding: 6 }}>No responses available</div>}
              {textResponsesForDropdown.map((r, idx) => {
                const checked = selectedTextResponses.includes(r);
                return (
                  <label key={idx} style={{ display: "flex", alignItems: "flex-start", gap: 8, padding: "6px 4px", cursor: "pointer" }}>
                    <input type="checkbox" checked={checked} onClick={(e) => e.stopPropagation()} onChange={() => setSelectedTextResponses(prev => checked ? prev.filter(x => x !== r) : [...prev, r]) } />
                    <span style={{ fontSize: 13 }}>{r.response}</span>
                  </label>
                );
              })}
            </div>
          )}
        </div>
      )}

      <button onClick={addSlideToQueue} style={{ marginTop: 15, padding: "8px 16px", background: "#0b6efd", color: "white", border: "none", borderRadius: 6, cursor: "pointer" }}>
        ➕ Add This Slide to PPT Queue
      </button>

      <div style={{ marginTop: 20 }}>
        <h3>Slides Added: {slideQueue.length}</h3>
        {slideQueue.map((s, i) => (
          <div key={i} style={{ padding: 10, border: "1px solid #ddd", borderRadius: 6, marginBottom: 10 }}>
            <b>Slide {i + 1}:</b> <br />
            Title: {s.title} <br />
            Level: {s.level} <br />
            Departments: {s.selectedDepts.join(", ")}<br />
            Groups: {s.selectedGroups.join(", ")}<br />
            Mode: {s.mode}<br />
            Chart Type: {s.chartType}<br />
            <button onClick={() => removeSlide(i)} style={{ marginTop: 5, padding: "4px 10px", background: "red", color: "#fff", border: "none", borderRadius: 4, cursor: "pointer" }}>
              Remove
            </button>
          </div>
        ))}
      </div>

      <div className="preview-panel">
        {chartType === "bar" && (
          <div style={{ width: "100%", height: 420 }}>
            <Bar data={chartData} options={chartOptions} />
          </div>
        )}

        {chartType === "pie" && (
          <div style={{ display: "flex", gap: 20, flexWrap: "wrap" }}>
            {selectedDepts.map((dept) => {
              const totals = calculatePieTotals(dept);
              return (
                <div key={dept} style={{ width: 300 }}>
                  <h4 style={{ textAlign: "center" }}>{dept}</h4>
                  <Pie data={{ labels: LABEL_ORDER, datasets: [{ data: [totals.sa, totals.a, totals.d, totals.sd], backgroundColor: [pieColors.sa, pieColors.a, pieColors.d, pieColors.sd] }] }} options={{ plugins: { legend: { position: "bottom" }, datalabels: { color: "#fff", formatter: (v) => `${v}%`, font: { size: 14, weight: "bold" } } } }} />
                </div>
              );
            })}
            {selectedDepts.length === 0 && <div>Select departments to preview pies</div>}
          </div>
        )}

        {chartType === "radar" && (
          <div style={{ width: "100%", height: 420 }}>
            <Radar data={radarChartData} options={{ responsive: true, scales: { r: { min: 0, max: 100, ticks: { stepSize: 20 } } }, plugins: { legend: { position: "bottom" } } }} />
          </div>
        )}

        {chartType === "waffle" && (
          <div style={{ display: "flex", gap: 24, flexWrap: "wrap" }}>
            {selectedDepts.map((dept) => {
              const deptObj = data.find(d => d.department === dept && (selectedLevel === "All" || d.level === selectedLevel));
              if (!deptObj) return null;
              let pos = 0, neg = 0, count = 0;
              deptObj.groups.forEach(g => {
                if (!selectedGroups.includes(g.group)) return;
                pos += g.positive_percent || 0; neg += g.negative_percent || 0; count++;
              });
              return <WaffleChart key={dept} title={dept} positive={count ? Math.round(pos / count) : 0} negative={count ? Math.round(neg / count) : 0} />;
            })}
          </div>
        )}

        {chartType === "waffle-total" && (
          <div style={{ display: "flex", gap: 24, alignItems: "flex-start" }}>
            <WaffleChart title="Overall Participation" mode="total" data={(() => {
                const total = (data || []).reduce((sum, d) => sum + (d.responses || 0), 0);
                return (data || []).map(d => ({ label: d.department, value: total ? Math.round((d.responses / total) * 100) : 0 }));
              })()} />
            <div>
              <h4 style={{ marginBottom: 8 }}>Departments</h4>
              {(data || []).map(d => <div key={d.department} style={{ fontSize: 14, marginBottom: 4 }}>■ {d.department}</div>)}
            </div>
          </div>
        )}
      </div>

      <button onClick={downloadPPT} className="download-btn">
        ⬇ Download PPT (All Slides)
      </button>
    </div>
  );
}